const tokens = {
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--bJeTGz)"
  },
  "animations.ping": {
    "value": "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    "variable": "var(--cxTetH)"
  },
  "animations.pulse": {
    "value": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    "variable": "var(--jjLJjo)"
  },
  "animations.bounce": {
    "value": "bounce 1s infinite",
    "variable": "var(--eUTuJH)"
  },
  "aspectRatios.square": {
    "value": "1 / 1",
    "variable": "var(--cUJial)"
  },
  "aspectRatios.landscape": {
    "value": "4 / 3",
    "variable": "var(--joSgrv)"
  },
  "aspectRatios.portrait": {
    "value": "3 / 4",
    "variable": "var(--dXjFHz)"
  },
  "aspectRatios.wide": {
    "value": "16 / 9",
    "variable": "var(--gqpqIn)"
  },
  "aspectRatios.ultrawide": {
    "value": "18 / 5",
    "variable": "var(--lixcAJ)"
  },
  "aspectRatios.golden": {
    "value": "1.618 / 1",
    "variable": "var(--hSWVDT)"
  },
  "blurs.sm": {
    "value": "0.25rem",
    "variable": "var(--aZLOC)"
  },
  "blurs.base": {
    "value": "0.5rem",
    "variable": "var(--jDYzax)"
  },
  "blurs.md": {
    "value": "0.75rem",
    "variable": "var(--kMMDaR)"
  },
  "blurs.lg": {
    "value": "1rem",
    "variable": "var(--dyIDQb)"
  },
  "blurs.xl": {
    "value": "1.5rem",
    "variable": "var(--TtVDs)"
  },
  "blurs.2xl": {
    "value": "2.5rem",
    "variable": "var(--btncja)"
  },
  "blurs.3xl": {
    "value": "4rem",
    "variable": "var(--esAhmv)"
  },
  "borderWidths.xs": {
    "value": "0.03125rem",
    "variable": "var(--kYFOek)"
  },
  "borderWidths.sm": {
    "value": "0.0625rem",
    "variable": "var(--cjTwZZ)"
  },
  "borderWidths.md": {
    "value": "0.09375rem",
    "variable": "var(--dvTIcW)"
  },
  "borderWidths.lg": {
    "value": "0.125rem",
    "variable": "var(--jBUvqk)"
  },
  "borderWidths.xl": {
    "value": "0.1875rem",
    "variable": "var(--hRTFLr)"
  },
  "borderWidths.2xl": {
    "value": "0.3125rem",
    "variable": "var(--bWHwp)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--fuVfvZ)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--fVBMec)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--mUhz)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--cWTXGg)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--cifMdM)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--goNNlj)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--bPXfWW)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--drrWcF)"
  },
  "easings.linear": {
    "value": "linear",
    "variable": "var(--hgfxJf)"
  },
  "easings.in": {
    "value": "cubic-bezier(0.4, 0, 1, 1)",
    "variable": "var(--hCLxzh)"
  },
  "easings.out": {
    "value": "cubic-bezier(0, 0, 0.2, 1)",
    "variable": "var(--byCBno)"
  },
  "easings.in-out": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--gSAVQW)"
  },
  "fonts.sans": {
    "value": "var(--font-lato, Lato), ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Helvetica, Arial, \"Noto Sans\", sans-serif",
    "variable": "var(--dywXPJ)"
  },
  "fonts.mono": {
    "value": "ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, \"Liberation Mono\", monospace",
    "variable": "var(--gxQaAd)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--kWjDjq)"
  },
  "fontSizes.xs": {
    "value": "0.625rem",
    "variable": "var(--loLyxA)"
  },
  "fontSizes.sm": {
    "value": "0.75rem",
    "variable": "var(--eRgJXV)"
  },
  "fontSizes.md": {
    "value": "0.875rem",
    "variable": "var(--daFrau)"
  },
  "fontSizes.base": {
    "value": "1rem",
    "variable": "var(--mCmFS)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--gKFLFQ)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--gFqSQX)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--dllMvh)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--fVSZDc)"
  },
  "fontWeights.regular": {
    "value": "400",
    "variable": "var(--TgeWs)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--ghWdwL)"
  },
  "letterSpacings.-xs": {
    "value": "-0.015rem",
    "variable": "var(--daypNM)"
  },
  "letterSpacings.xs": {
    "value": "0.0125rem",
    "variable": "var(--kPotep)"
  },
  "letterSpacings.sm": {
    "value": "0.015rem",
    "variable": "var(--jLseyA)"
  },
  "letterSpacings.md": {
    "value": "0.0175rem",
    "variable": "var(--cIeEcL)"
  },
  "letterSpacings.lg": {
    "value": "0.02rem",
    "variable": "var(--eWuxBJ)"
  },
  "letterSpacings.xl": {
    "value": "0.025rem",
    "variable": "var(--jJiTSq)"
  },
  "letterSpacings.2xl": {
    "value": "0.03rem",
    "variable": "var(--QPeIA)"
  },
  "letterSpacings.3xl": {
    "value": "0.035rem",
    "variable": "var(--dfAEdN)"
  },
  "letterSpacings.4xl": {
    "value": "0.0375rem",
    "variable": "var(--cZfRYS)"
  },
  "letterSpacings.5xl": {
    "value": "0.04rem",
    "variable": "var(--fnRruf)"
  },
  "letterSpacings.6xl": {
    "value": "0.045rem",
    "variable": "var(--boVsOg)"
  },
  "letterSpacings.7xl": {
    "value": "0.05rem",
    "variable": "var(--dDGSjt)"
  },
  "letterSpacings.8xl": {
    "value": "0.0525rem",
    "variable": "var(--buMtEa)"
  },
  "letterSpacings.9xl": {
    "value": "0.06rem",
    "variable": "var(--dJxSZn)"
  },
  "letterSpacings.10xl": {
    "value": "0.0675rem",
    "variable": "var(--PgsAj)"
  },
  "letterSpacings.11xl": {
    "value": "0.075rem",
    "variable": "var(--ilJXky)"
  },
  "lineHeights.2xs": {
    "value": "0.75rem",
    "variable": "var(--fDdwSd)"
  },
  "lineHeights.xs": {
    "value": "0.875rem",
    "variable": "var(--logoxv)"
  },
  "lineHeights.sm": {
    "value": "1rem",
    "variable": "var(--hbnpoS)"
  },
  "lineHeights.md": {
    "value": "1.25rem",
    "variable": "var(--ckAamt)"
  },
  "lineHeights.lg": {
    "value": "1.5rem",
    "variable": "var(--gwHNPD)"
  },
  "lineHeights.xl": {
    "value": "1.625rem",
    "variable": "var(--jLpFxc)"
  },
  "lineHeights.2xl": {
    "value": "1.875rem",
    "variable": "var(--iRQcJq)"
  },
  "lineHeights.3xl": {
    "value": "2rem",
    "variable": "var(--jLNnjP)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--dbrZvb)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--ixNmpi)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--bewZvn)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--kLOfAE)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--dxfumK)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--UXfgJ)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--bphCwb)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--eougbK)"
  },
  "radii.4xl": {
    "value": "2rem",
    "variable": "var(--holyYx)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--kkkBVq)"
  },
  "shadows.xs": {
    "value": "0 0.0625rem 0.1875rem 0 var(--cglRlA)",
    "variable": "var(--bUWovs)"
  },
  "shadows.sm": {
    "value": "0 0.1875rem 0.625rem -0.1875rem var(--jVpJol)",
    "variable": "var(--cDhNnp)"
  },
  "shadows.md": {
    "value": "0 0.625rem 2.25rem -0.5rem var(--fQoWgS)",
    "variable": "var(--jMKUKK)"
  },
  "shadows.lg": {
    "value": "0 0.75rem 3rem -0.5rem var(--ljFrmg)",
    "variable": "var(--kNVcRA)"
  },
  "shadows.xl": {
    "value": "0 0.875rem 3.125rem -0.5rem var(--eSqzdn)",
    "variable": "var(--bnVgij)"
  },
  "shadows.xs.inverted": {
    "value": "0 0.0625rem 0.1875rem 0 var(--SfrEW)",
    "variable": "var(--ixPyqR)"
  },
  "shadows.sm.inverted": {
    "value": "0 0.1875rem 0.625rem -0.1875rem var(--iUtXvz)",
    "variable": "var(--sQOUM)"
  },
  "shadows.md.inverted": {
    "value": "0 0.625rem 2.25rem -0.5rem var(--cJFoBE)",
    "variable": "var(--jzAbcr)"
  },
  "shadows.lg.inverted": {
    "value": "0 0.75rem 3rem -0.5rem var(--iZeAoG)",
    "variable": "var(--kUmttF)"
  },
  "shadows.xl.inverted": {
    "value": "0 0.875rem 3.125rem -0.5rem var(--hzgTEF)",
    "variable": "var(--gvIBbW)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--kTdGYg)"
  },
  "sizes.6xs": {
    "value": "0rem",
    "variable": "var(--bbhOUl)"
  },
  "sizes.px": {
    "value": "0.0625rem",
    "variable": "var(--blEJOM)"
  },
  "sizes.5xs": {
    "value": "0.125rem",
    "variable": "var(--eRhXXC)"
  },
  "sizes.4xs": {
    "value": "0.25rem",
    "variable": "var(--hQuBDn)"
  },
  "sizes.3xs": {
    "value": "0.375rem",
    "variable": "var(--kPIhZA)"
  },
  "sizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--czzcgp)"
  },
  "sizes.xs": {
    "value": "0.625rem",
    "variable": "var(--izvCpj)"
  },
  "sizes.sm": {
    "value": "0.75rem",
    "variable": "var(--aTIGG)"
  },
  "sizes.md": {
    "value": "0.875rem",
    "variable": "var(--kMQJUV)"
  },
  "sizes.base": {
    "value": "1rem",
    "variable": "var(--jDUQql)"
  },
  "sizes.lg": {
    "value": "1.125rem",
    "variable": "var(--dyNKmL)"
  },
  "sizes.xl": {
    "value": "1.25rem",
    "variable": "var(--ToPgI)"
  },
  "sizes.2xl": {
    "value": "1.375rem",
    "variable": "var(--btoFLe)"
  },
  "sizes.3xl": {
    "value": "1.5rem",
    "variable": "var(--esBjqP)"
  },
  "sizes.4xl": {
    "value": "1.75rem",
    "variable": "var(--hrOPNc)"
  },
  "sizes.5xl": {
    "value": "2rem",
    "variable": "var(--krbtsN)"
  },
  "sizes.6xl": {
    "value": "2.25rem",
    "variable": "var(--cRFSXi)"
  },
  "sizes.7xl": {
    "value": "2.5rem",
    "variable": "var(--fQSwCT)"
  },
  "sizes.8xl": {
    "value": "2.75rem",
    "variable": "var(--iQceEA)"
  },
  "sizes.9xl": {
    "value": "3rem",
    "variable": "var(--zSYLp)"
  },
  "sizes.10xl": {
    "value": "3.5rem",
    "variable": "var(--iiiXEd)"
  },
  "sizes.11xl": {
    "value": "4rem",
    "variable": "var(--gUfIkI)"
  },
  "sizes.12xl": {
    "value": "5rem",
    "variable": "var(--gPKwhD)"
  },
  "sizes.13xl": {
    "value": "6rem",
    "variable": "var(--fBHgOi)"
  },
  "sizes.14xl": {
    "value": "7rem",
    "variable": "var(--dSjDBJ)"
  },
  "sizes.15xl": {
    "value": "8rem",
    "variable": "var(--cEgoio)"
  },
  "sizes.16xl": {
    "value": "9rem",
    "variable": "var(--czLcfj)"
  },
  "sizes.17xl": {
    "value": "10rem",
    "variable": "var(--blHMLO)"
  },
  "sizes.18xl": {
    "value": "11rem",
    "variable": "var(--kRBUDF)"
  },
  "sizes.19xl": {
    "value": "12rem",
    "variable": "var(--jDyFkk)"
  },
  "sizes.20xl": {
    "value": "13rem",
    "variable": "var(--INxiy)"
  },
  "sizes.21xl": {
    "value": "14rem",
    "variable": "var(--eoZZob)"
  },
  "sizes.22xl": {
    "value": "15rem",
    "variable": "var(--hCsZUI)"
  },
  "sizes.23xl": {
    "value": "16rem",
    "variable": "var(--liFCal)"
  },
  "sizes.24xl": {
    "value": "18rem",
    "variable": "var(--hIjMFa)"
  },
  "sizes.25xl": {
    "value": "20rem",
    "variable": "var(--lowoKD)"
  },
  "sizes.26xl": {
    "value": "24rem",
    "variable": "var(--dmtFSo)"
  },
  "sizes.27xl": {
    "value": "28rem",
    "variable": "var(--gSGhXR)"
  },
  "sizes.28xl": {
    "value": "32rem",
    "variable": "var(--dsguia)"
  },
  "sizes.29xl": {
    "value": "36rem",
    "variable": "var(--gYsWnD)"
  },
  "sizes.30xl": {
    "value": "40rem",
    "variable": "var(--dIaaOj)"
  },
  "sizes.prose": {
    "value": "65ch",
    "variable": "var(--jAesVz)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--khWApH)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--eOXrSu)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--jNBRbM)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--UhpHH)"
  },
  "sizes.breakpoint-sm": {
    "value": "40rem",
    "variable": "var(--eomHOU)"
  },
  "sizes.breakpoint-md": {
    "value": "48rem",
    "variable": "var(--iujnmj)"
  },
  "sizes.breakpoint-lg": {
    "value": "64rem",
    "variable": "var(--gThSgZ)"
  },
  "sizes.breakpoint-xl": {
    "value": "80rem",
    "variable": "var(--cssArG)"
  },
  "sizes.breakpoint-2xl": {
    "value": "96rem",
    "variable": "var(--jESPPc)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--fcTUxn)"
  },
  "spacing.6xs": {
    "value": "0rem",
    "variable": "var(--dxAUme)"
  },
  "spacing.px": {
    "value": "0.0625rem",
    "variable": "var(--dnyzTn)"
  },
  "spacing.5xs": {
    "value": "0.125rem",
    "variable": "var(--eySuft)"
  },
  "spacing.4xs": {
    "value": "0.25rem",
    "variable": "var(--cwbymM)"
  },
  "spacing.3xs": {
    "value": "0.375rem",
    "variable": "var(--cVdxOb)"
  },
  "spacing.2xs": {
    "value": "0.5rem",
    "variable": "var(--SmBVu)"
  },
  "spacing.xs": {
    "value": "0.625rem",
    "variable": "var(--icrUDE)"
  },
  "spacing.sm": {
    "value": "0.75rem",
    "variable": "var(--jolVMp)"
  },
  "spacing.md": {
    "value": "0.875rem",
    "variable": "var(--eEeglK)"
  },
  "spacing.base": {
    "value": "1rem",
    "variable": "var(--gViRqS)"
  },
  "spacing.lg": {
    "value": "1.125rem",
    "variable": "var(--fFUZAQ)"
  },
  "spacing.xl": {
    "value": "1.25rem",
    "variable": "var(--gvVjyT)"
  },
  "spacing.2xl": {
    "value": "1.375rem",
    "variable": "var(--ceCtBJ)"
  },
  "spacing.3xl": {
    "value": "1.5rem",
    "variable": "var(--bLxJc)"
  },
  "spacing.4xl": {
    "value": "1.75rem",
    "variable": "var(--ANxkr)"
  },
  "spacing.5xl": {
    "value": "2rem",
    "variable": "var(--jNskQG)"
  },
  "spacing.6xl": {
    "value": "2.25rem",
    "variable": "var(--kOJKJV)"
  },
  "spacing.7xl": {
    "value": "2.5rem",
    "variable": "var(--iLSORo)"
  },
  "spacing.8xl": {
    "value": "2.75rem",
    "variable": "var(--dpgZwD)"
  },
  "spacing.9xl": {
    "value": "3rem",
    "variable": "var(--bmqdDW)"
  },
  "spacing.10xl": {
    "value": "3.5rem",
    "variable": "var(--loYIla)"
  },
  "spacing.11xl": {
    "value": "4rem",
    "variable": "var(--fLRwFr)"
  },
  "spacing.12xl": {
    "value": "5rem",
    "variable": "var(--dEKpsg)"
  },
  "spacing.13xl": {
    "value": "6rem",
    "variable": "var(--jqYNlt)"
  },
  "spacing.14xl": {
    "value": "7rem",
    "variable": "var(--hcMAW)"
  },
  "spacing.15xl": {
    "value": "8rem",
    "variable": "var(--fTrkuj)"
  },
  "spacing.16xl": {
    "value": "9rem",
    "variable": "var(--dMkdgY)"
  },
  "spacing.17xl": {
    "value": "10rem",
    "variable": "var(--jyyBal)"
  },
  "spacing.18xl": {
    "value": "11rem",
    "variable": "var(--fIkuSK)"
  },
  "spacing.19xl": {
    "value": "12rem",
    "variable": "var(--fdjnb)"
  },
  "spacing.20xl": {
    "value": "13rem",
    "variable": "var(--aUyFt)"
  },
  "spacing.21xl": {
    "value": "14rem",
    "variable": "var(--hmVpc)"
  },
  "spacing.22xl": {
    "value": "15rem",
    "variable": "var(--izoUL)"
  },
  "spacing.23xl": {
    "value": "16rem",
    "variable": "var(--kEnvdq)"
  },
  "spacing.24xl": {
    "value": "18rem",
    "variable": "var(--biumul)"
  },
  "spacing.25xl": {
    "value": "20rem",
    "variable": "var(--oMJdU)"
  },
  "spacing.26xl": {
    "value": "24rem",
    "variable": "var(--pZcJD)"
  },
  "colors.white.50": {
    "value": "#FFFFFF",
    "variable": "var(--eeGIcH)"
  },
  "colors.white.100": {
    "value": "#F2F2F2",
    "variable": "var(--bixyZH)"
  },
  "colors.white.200": {
    "value": "#E6E6E6",
    "variable": "var(--kRxGXQ)"
  },
  "colors.white.300": {
    "value": "#D9D9D9",
    "variable": "var(--fLPsaF)"
  },
  "colors.white.400": {
    "value": "#D9D9D9",
    "variable": "var(--iKqRUq)"
  },
  "colors.white.500": {
    "value": "#BFBFBF",
    "variable": "var(--dEICXf)"
  },
  "colors.white.600": {
    "value": "#B3B3B3",
    "variable": "var(--bYnbws)"
  },
  "colors.white.700": {
    "value": "#A6A6A6",
    "variable": "var(--iiavYd)"
  },
  "colors.white.800": {
    "value": "#999999",
    "variable": "var(--cEHtTa)"
  },
  "colors.white.900": {
    "value": "#8C8C8C",
    "variable": "var(--iOuOuL)"
  },
  "colors.black.50": {
    "value": "#737373",
    "variable": "var(--khVlkr)"
  },
  "colors.black.100": {
    "value": "#666666",
    "variable": "var(--hFkmof)"
  },
  "colors.black.200": {
    "value": "#595959",
    "variable": "var(--gYUVhI)"
  },
  "colors.black.300": {
    "value": "#4D4D4D",
    "variable": "var(--iDmitd)"
  },
  "colors.black.400": {
    "value": "#404040",
    "variable": "var(--jGMWzK)"
  },
  "colors.black.500": {
    "value": "#333333",
    "variable": "var(--llejLf)"
  },
  "colors.black.600": {
    "value": "#262626",
    "variable": "var(--kEOSEI)"
  },
  "colors.black.700": {
    "value": "#1A1A1A",
    "variable": "var(--TKwrh)"
  },
  "colors.black.800": {
    "value": "#0D0D0D",
    "variable": "var(--hWneu)"
  },
  "colors.black.900": {
    "value": "#000000",
    "variable": "var(--bMnApP)"
  },
  "colors.blue.50": {
    "value": "#F0F5FE",
    "variable": "var(--glmLoi)"
  },
  "colors.blue.100": {
    "value": "#D7E3FE",
    "variable": "var(--bYrJpO)"
  },
  "colors.blue.200": {
    "value": "#AFC6FD",
    "variable": "var(--hoTvPd)"
  },
  "colors.blue.300": {
    "value": "#86A6FB",
    "variable": "var(--bMEoOM)"
  },
  "colors.blue.400": {
    "value": "#688BF8",
    "variable": "var(--hIEEwj)"
  },
  "colors.blue.500": {
    "value": "#3761F4",
    "variable": "var(--cgpxvS)"
  },
  "colors.blue.600": {
    "value": "#2849D1",
    "variable": "var(--hwRjVh)"
  },
  "colors.blue.700": {
    "value": "#1B35AF",
    "variable": "var(--bUCcUQ)"
  },
  "colors.blue.800": {
    "value": "#11248D",
    "variable": "var(--golFsv)"
  },
  "colors.blue.900": {
    "value": "#0A1875",
    "variable": "var(--LWyse)"
  },
  "colors.honey.50": {
    "value": "#FEFAF0",
    "variable": "var(--zbjPx)"
  },
  "colors.honey.100": {
    "value": "#FEF3D6",
    "variable": "var(--dwWFld)"
  },
  "colors.honey.200": {
    "value": "#FEE4AE",
    "variable": "var(--gpJVmS)"
  },
  "colors.honey.300": {
    "value": "#FDD185",
    "variable": "var(--YMsiT)"
  },
  "colors.honey.400": {
    "value": "#FBBE66",
    "variable": "var(--GfEUs)"
  },
  "colors.honey.500": {
    "value": "#F99F35",
    "variable": "var(--gEDLpp)"
  },
  "colors.honey.600": {
    "value": "#D67D26",
    "variable": "var(--jxrbre)"
  },
  "colors.honey.700": {
    "value": "#B35F1A",
    "variable": "var(--egtynf)"
  },
  "colors.honey.800": {
    "value": "#904410",
    "variable": "var(--jbuDns)"
  },
  "colors.honey.900": {
    "value": "#77310A",
    "variable": "var(--dKxajt)"
  },
  "colors.slate.50": {
    "value": "#F8FAFC",
    "variable": "var(--kcXOlL)"
  },
  "colors.slate.100": {
    "value": "#F1F5F9",
    "variable": "var(--kbRDfH)"
  },
  "colors.slate.200": {
    "value": "#E2E8F0",
    "variable": "var(--ivwbEU)"
  },
  "colors.slate.300": {
    "value": "#CBD5E1",
    "variable": "var(--dpNMHJ)"
  },
  "colors.slate.400": {
    "value": "#94A3B8",
    "variable": "var(--dtmoEy)"
  },
  "colors.slate.500": {
    "value": "#64748B",
    "variable": "var(--jCZJgj)"
  },
  "colors.slate.600": {
    "value": "#475569",
    "variable": "var(--hWEhFw)"
  },
  "colors.slate.700": {
    "value": "#334155",
    "variable": "var(--cQVSIl)"
  },
  "colors.slate.800": {
    "value": "#1E293B",
    "variable": "var(--hVLXiS)"
  },
  "colors.slate.900": {
    "value": "#0F172A",
    "variable": "var(--cQdIlH)"
  },
  "colors.green.50": {
    "value": "#F0FEF2",
    "variable": "var(--hXozqf)"
  },
  "colors.green.100": {
    "value": "#C9FBCF",
    "variable": "var(--iDDIAz)"
  },
  "colors.green.200": {
    "value": "#94F7AA",
    "variable": "var(--khfuXU)"
  },
  "colors.green.300": {
    "value": "#5DE989",
    "variable": "var(--hypAVx)"
  },
  "colors.green.400": {
    "value": "#35D477",
    "variable": "var(--wGfza)"
  },
  "colors.green.500": {
    "value": "#00B85F",
    "variable": "var(--jdlUVz)"
  },
  "colors.green.600": {
    "value": "#009E61",
    "variable": "var(--kGNHsU)"
  },
  "colors.green.700": {
    "value": "#00845E",
    "variable": "var(--hXXNqx)"
  },
  "colors.green.800": {
    "value": "#006A57",
    "variable": "var(--bAQeLK)"
  },
  "colors.green.900": {
    "value": "#005850",
    "variable": "var(--khvUij)"
  },
  "colors.mustard.50": {
    "value": "#FEFCF0",
    "variable": "var(--cnSQSw)"
  },
  "colors.mustard.100": {
    "value": "#FEF9D7",
    "variable": "var(--dXSKck)"
  },
  "colors.mustard.200": {
    "value": "#FDF2AF",
    "variable": "var(--gjXguH)"
  },
  "colors.mustard.300": {
    "value": "#FBE786",
    "variable": "var(--rPjpu)"
  },
  "colors.mustard.400": {
    "value": "#F8DC68",
    "variable": "var(--eUBpbZ)"
  },
  "colors.mustard.500": {
    "value": "#F4CB37",
    "variable": "var(--krPbvI)"
  },
  "colors.mustard.600": {
    "value": "#D1A928",
    "variable": "var(--boxOpj)"
  },
  "colors.mustard.700": {
    "value": "#AF881B",
    "variable": "var(--gLLAIS)"
  },
  "colors.mustard.800": {
    "value": "#8D6A11",
    "variable": "var(--lpslKB)"
  },
  "colors.mustard.900": {
    "value": "#75540A",
    "variable": "var(--fxkoFo)"
  },
  "colors.red.50": {
    "value": "#FEF5F0",
    "variable": "var(--bINrJX)"
  },
  "colors.red.100": {
    "value": "#FEE4D7",
    "variable": "var(--fKgVwH)"
  },
  "colors.red.200": {
    "value": "#FDC3AF",
    "variable": "var(--bLdQLg)"
  },
  "colors.red.300": {
    "value": "#FB9A86",
    "variable": "var(--fMUQaR)"
  },
  "colors.red.400": {
    "value": "#F87468",
    "variable": "var(--hwCQam)"
  },
  "colors.red.500": {
    "value": "#F43737",
    "variable": "var(--iYfRb)"
  },
  "colors.red.600": {
    "value": "#D12836",
    "variable": "var(--hzqKEw)"
  },
  "colors.red.700": {
    "value": "#AF1B35",
    "variable": "var(--lMavl)"
  },
  "colors.red.800": {
    "value": "#8D1131",
    "variable": "var(--bLDcWa)"
  },
  "colors.red.900": {
    "value": "#750A2F",
    "variable": "var(--fNuclL)"
  },
  "colors.cyan.50": {
    "value": "#F0FDFE",
    "variable": "var(--dyXAhp)"
  },
  "colors.cyan.100": {
    "value": "#D7FBFE",
    "variable": "var(--eeWoox)"
  },
  "colors.cyan.200": {
    "value": "#AFF2FE",
    "variable": "var(--fnHbwe)"
  },
  "colors.cyan.300": {
    "value": "#87E4FC",
    "variable": "var(--cLmYYf)"
  },
  "colors.cyan.400": {
    "value": "#68D2F9",
    "variable": "var(--bpLSHw)"
  },
  "colors.cyan.500": {
    "value": "#38B6F5",
    "variable": "var(--kcNzIt)"
  },
  "colors.cyan.600": {
    "value": "#288FD2",
    "variable": "var(--llymQa)"
  },
  "colors.cyan.700": {
    "value": "#1C6BB0",
    "variable": "var(--iJeksb)"
  },
  "colors.cyan.800": {
    "value": "#114C8E",
    "variable": "var(--jTKpqw)"
  },
  "colors.cyan.900": {
    "value": "#0A3675",
    "variable": "var(--hrqmSx)"
  },
  "colors.fuchsia.50": {
    "value": "#FEF0FE",
    "variable": "var(--kpTESD)"
  },
  "colors.fuchsia.100": {
    "value": "#FED7FE",
    "variable": "var(--jfJgr)"
  },
  "colors.fuchsia.200": {
    "value": "#F7AFFD",
    "variable": "var(--gZeVto)"
  },
  "colors.fuchsia.300": {
    "value": "#EA86FB",
    "variable": "var(--gfHpEZ)"
  },
  "colors.fuchsia.400": {
    "value": "#D968F8",
    "variable": "var(--dSTUoK)"
  },
  "colors.fuchsia.500": {
    "value": "#BF37F4",
    "variable": "var(--cZwoAv)"
  },
  "colors.fuchsia.600": {
    "value": "#9628D1",
    "variable": "var(--jPvANs)"
  },
  "colors.fuchsia.700": {
    "value": "#711BAF",
    "variable": "var(--iVXUZd)"
  },
  "colors.fuchsia.800": {
    "value": "#51118D",
    "variable": "var(--hYKnEO)"
  },
  "colors.fuchsia.900": {
    "value": "#3A0A75",
    "variable": "var(--hfmHQz)"
  },
  "colors.purple.50": {
    "value": "#F6F0FE",
    "variable": "var(--ksTgfC)"
  },
  "colors.purple.100": {
    "value": "#E8D7FE",
    "variable": "var(--iCdJRO)"
  },
  "colors.purple.200": {
    "value": "#D0AFFD",
    "variable": "var(--dWAXWh)"
  },
  "colors.purple.300": {
    "value": "#B486FB",
    "variable": "var(--jcWlLI)"
  },
  "colors.purple.400": {
    "value": "#9B68F8",
    "variable": "var(--eLlnzT)"
  },
  "colors.purple.500": {
    "value": "#7437F4",
    "variable": "var(--jRGBpu)"
  },
  "colors.purple.600": {
    "value": "#5928D1",
    "variable": "var(--fmdPtN)"
  },
  "colors.purple.700": {
    "value": "#411BAF",
    "variable": "var(--kszdjo)"
  },
  "colors.purple.800": {
    "value": "#2D118D",
    "variable": "var(--kMigIv)"
  },
  "colors.purple.900": {
    "value": "#1E0A75",
    "variable": "var(--eDhKZa)"
  },
  "colors.pink.50": {
    "value": "#FEF0F0",
    "variable": "var(--hPYfGc)"
  },
  "colors.pink.100": {
    "value": "#FED7D7",
    "variable": "var(--ioAkJk)"
  },
  "colors.pink.200": {
    "value": "#FDAFB9",
    "variable": "var(--eyVWNz)"
  },
  "colors.pink.300": {
    "value": "#FB86A0",
    "variable": "var(--nXIqK)"
  },
  "colors.pink.400": {
    "value": "#F86896",
    "variable": "var(--hGgStN)"
  },
  "colors.pink.500": {
    "value": "#F43787",
    "variable": "var(--dviDWY)"
  },
  "colors.pink.600": {
    "value": "#D12880",
    "variable": "var(--kUZZAj)"
  },
  "colors.pink.700": {
    "value": "#AF1B77",
    "variable": "var(--gKbLdu)"
  },
  "colors.pink.800": {
    "value": "#8D116B",
    "variable": "var(--UhnuV)"
  },
  "colors.pink.900": {
    "value": "#750A62",
    "variable": "var(--hYEIxc)"
  },
  "colors.rose.50": {
    "value": "#FEF3F0",
    "variable": "var(--cQacUT)"
  },
  "colors.rose.100": {
    "value": "#FEDFD7",
    "variable": "var(--fFtaKH)"
  },
  "colors.rose.200": {
    "value": "#FEB8AF",
    "variable": "var(--eUoFZM)"
  },
  "colors.rose.300": {
    "value": "#FC8887",
    "variable": "var(--bPMUxN)"
  },
  "colors.rose.400": {
    "value": "#F96874",
    "variable": "var(--bvZVli)"
  },
  "colors.rose.500": {
    "value": "#F53859",
    "variable": "var(--jGTTif)"
  },
  "colors.rose.600": {
    "value": "#D22856",
    "variable": "var(--iVPyxk)"
  },
  "colors.rose.700": {
    "value": "#B01C52",
    "variable": "var(--fRnMVl)"
  },
  "colors.rose.800": {
    "value": "#8E114A",
    "variable": "var(--hxzBoW)"
  },
  "colors.rose.900": {
    "value": "#750A45",
    "variable": "var(--esXPMX)"
  },
  "colors.orange.50": {
    "value": "#FEF8F0",
    "variable": "var(--NQTLQ)"
  },
  "colors.orange.100": {
    "value": "#FEEDD7",
    "variable": "var(--JsfmQ)"
  },
  "colors.orange.200": {
    "value": "#FDD5AF",
    "variable": "var(--gBjjlD)"
  },
  "colors.orange.300": {
    "value": "#FBB886",
    "variable": "var(--QMCLK)"
  },
  "colors.orange.400": {
    "value": "#F89B68",
    "variable": "var(--ijESlZ)"
  },
  "colors.orange.500": {
    "value": "#F46D37",
    "variable": "var(--czilMg)"
  },
  "colors.orange.600": {
    "value": "#D14D28",
    "variable": "var(--iqZpKT)"
  },
  "colors.orange.700": {
    "value": "#AF311B",
    "variable": "var(--cGCJla)"
  },
  "colors.orange.800": {
    "value": "#8D1B11",
    "variable": "var(--dUhLNN)"
  },
  "colors.orange.900": {
    "value": "#750C0A",
    "variable": "var(--jzgOMQ)"
  },
  "colors.brown.50": {
    "value": "#FFF9EB",
    "variable": "var(--iikiuy)"
  },
  "colors.brown.100": {
    "value": "#FCF0D4",
    "variable": "var(--cIaIpq)"
  },
  "colors.brown.200": {
    "value": "#F9DDAA",
    "variable": "var(--ikbVBZ)"
  },
  "colors.brown.300": {
    "value": "#EFC17C",
    "variable": "var(--idYqrk)"
  },
  "colors.brown.400": {
    "value": "#E0A359",
    "variable": "var(--iffQOz)"
  },
  "colors.brown.500": {
    "value": "#CC7A29",
    "variable": "var(--hZclDK)"
  },
  "colors.brown.600": {
    "value": "#AF5E1D",
    "variable": "var(--clHPrx)"
  },
  "colors.brown.700": {
    "value": "#924614",
    "variable": "var(--cfEkgI)"
  },
  "colors.brown.800": {
    "value": "#76310D",
    "variable": "var(--iAUwdz)"
  },
  "colors.brown.900": {
    "value": "#612207",
    "variable": "var(--iuQQSK)"
  },
  "colors.yellow.50": {
    "value": "#FEFDE7",
    "variable": "var(--cLFWMs)"
  },
  "colors.yellow.100": {
    "value": "#FEFDD6",
    "variable": "var(--kxGpio)"
  },
  "colors.yellow.200": {
    "value": "#FDFAAE",
    "variable": "var(--cbZZGT)"
  },
  "colors.yellow.300": {
    "value": "#FBF585",
    "variable": "var(--fwcFBW)"
  },
  "colors.yellow.400": {
    "value": "#F7EF66",
    "variable": "var(--hUTJsd)"
  },
  "colors.yellow.500": {
    "value": "#F2E735",
    "variable": "var(--loWpng)"
  },
  "colors.yellow.600": {
    "value": "#D0C526",
    "variable": "var(--cTpZLL)"
  },
  "colors.yellow.700": {
    "value": "#AEA31A",
    "variable": "var(--gnsFGO)"
  },
  "colors.yellow.800": {
    "value": "#8C8210",
    "variable": "var(--ByZWN)"
  },
  "colors.yellow.900": {
    "value": "#746B0A",
    "variable": "var(--dVBFRQ)"
  },
  "colors.lime.50": {
    "value": "#FAFFEB",
    "variable": "var(--dhEleJ)"
  },
  "colors.lime.100": {
    "value": "#F3FCD5",
    "variable": "var(--gFFbyh)"
  },
  "colors.lime.200": {
    "value": "#E5FAAC",
    "variable": "var(--fjFsBy)"
  },
  "colors.lime.300": {
    "value": "#CFF281",
    "variable": "var(--cfdGZz)"
  },
  "colors.lime.400": {
    "value": "#B7E65F",
    "variable": "var(--bxLPEk)"
  },
  "colors.lime.500": {
    "value": "#95D62F",
    "variable": "var(--jIFNBh)"
  },
  "colors.lime.600": {
    "value": "#77B822",
    "variable": "var(--imGeEy)"
  },
  "colors.lime.700": {
    "value": "#5C9A17",
    "variable": "var(--fietcz)"
  },
  "colors.lime.800": {
    "value": "#447C0E",
    "variable": "var(--crovfQ)"
  },
  "colors.lime.900": {
    "value": "#336609",
    "variable": "var(--kCitcN)"
  },
  "colors.teal.50": {
    "value": "#E9FCF3",
    "variable": "var(--jqQOis)"
  },
  "colors.teal.100": {
    "value": "#CCF9E5",
    "variable": "var(--hsCMHs)"
  },
  "colors.teal.200": {
    "value": "#9BF4D5",
    "variable": "var(--jcJhxj)"
  },
  "colors.teal.300": {
    "value": "#65DFBF",
    "variable": "var(--czjDVi)"
  },
  "colors.teal.400": {
    "value": "#3CC0A9",
    "variable": "var(--kfgCt)"
  },
  "colors.teal.500": {
    "value": "#0D968B",
    "variable": "var(--eWbmzo)"
  },
  "colors.teal.600": {
    "value": "#097F81",
    "variable": "var(--gGhHpf)"
  },
  "colors.teal.700": {
    "value": "#06616C",
    "variable": "var(--cIdNe)"
  },
  "colors.teal.800": {
    "value": "#044757",
    "variable": "var(--catTvB)"
  },
  "colors.teal.900": {
    "value": "#023448",
    "variable": "var(--gMpZsw)"
  },
  "colors.graphite": {
    "value": "#1E1E1E",
    "variable": "var(--iJkpSs)"
  },
  "colors.neonGreen": {
    "value": "#D0F835",
    "variable": "var(--fXSZZR)"
  },
  "colors.violet": {
    "value": "#390B9A",
    "variable": "var(--fjqHUd)"
  },
  "colors.constructionOrange": {
    "value": "#FF4D00",
    "variable": "var(--iXzFmR)"
  },
  "colors.nickel": {
    "value": "#52530F",
    "variable": "var(--csfvqq)"
  },
  "colors.primaryBlue": {
    "value": "#4285F4",
    "variable": "var(--ckblUm)"
  },
  "colors.navy": {
    "value": "#2B3670",
    "variable": "var(--ipLVAU)"
  },
  "colors.magenta": {
    "value": "#F33859",
    "variable": "var(--dithMR)"
  },
  "colors.lightGrey": {
    "value": "#D4D5D8",
    "variable": "var(--ehwrNv)"
  },
  "colors.buttermilk": {
    "value": "#F6F7C9",
    "variable": "var(--kfnuBP)"
  },
  "colors.thistlePurple": {
    "value": "#BAACD9",
    "variable": "var(--kFVVgR)"
  },
  "colors.darkPurple": {
    "value": "#0C0236",
    "variable": "var(--jgsUfW)"
  },
  "colors.scheduleGantt.gridIconHoverBg": {
    "value": "rgba(100, 100, 100, 0.2)",
    "variable": "var(--kevVbY)"
  },
  "colors.manny.neon": {
    "value": "#d0f835",
    "variable": "var(--dEinqe)"
  },
  "colors.manny.orange": {
    "value": "#ff4d00",
    "variable": "var(--lBcAM)"
  },
  "colors.manny.blue": {
    "value": "#4285f4",
    "variable": "var(--gQiBYO)"
  },
  "colors.manny.violet": {
    "value": "#390b9a",
    "variable": "var(--jfIYR)"
  },
  "zIndex.base": {
    "value": 0,
    "variable": "var(--klLGSj)"
  },
  "zIndex.raised": {
    "value": 1,
    "variable": "var(--kGiKnG)"
  },
  "zIndex.sticky": {
    "value": 1000,
    "variable": "var(--eHQPzp)"
  },
  "zIndex.toolbar": {
    "value": 1050,
    "variable": "var(--guexED)"
  },
  "zIndex.panel": {
    "value": 1100,
    "variable": "var(--gOQlvM)"
  },
  "zIndex.overlay": {
    "value": 1200,
    "variable": "var(--gbwupQ)"
  },
  "zIndex.modal": {
    "value": 1300,
    "variable": "var(--dIktSh)"
  },
  "zIndex.dropdown": {
    "value": 1400,
    "variable": "var(--TWcuN)"
  },
  "zIndex.popover": {
    "value": 1500,
    "variable": "var(--beAiOT)"
  },
  "zIndex.contextMenu": {
    "value": 1600,
    "variable": "var(--hATCZe)"
  },
  "zIndex.notification": {
    "value": 1700,
    "variable": "var(--gxOjyr)"
  },
  "zIndex.max": {
    "value": 9999,
    "variable": "var(--exvVve)"
  },
  "zIndex.scheduler.subModalToast": {
    "value": 1299,
    "variable": "var(--gQHDue)"
  },
  "zIndex.scheduler.connectorMenu": {
    "value": 1299,
    "variable": "var(--GnBVk)"
  },
  "zIndex.scheduler.contextSubmenu": {
    "value": 1601,
    "variable": "var(--ecoErk)"
  },
  "zIndex.scheduler.contextSubmenuTooltip": {
    "value": 1602,
    "variable": "var(--dJVYvN)"
  },
  "zIndex.canvas.textNodeEditorToolbar": {
    "value": 20600,
    "variable": "var(--csvdry)"
  },
  "zIndex.canvas.connectionLine": {
    "value": 20600,
    "variable": "var(--emFjmX)"
  },
  "zIndex.scheduleGantt.dragLinkDecorative": {
    "value": 0,
    "variable": "var(--eKjNcu)"
  },
  "zIndex.scheduleGantt.lookaheadBand": {
    "value": 0,
    "variable": "var(--etDngd)"
  },
  "zIndex.scheduleGantt.baseLayer": {
    "value": 1,
    "variable": "var(--iRpdGQ)"
  },
  "zIndex.scheduleGantt.uiLayer": {
    "value": 2,
    "variable": "var(--dBgDad)"
  },
  "zIndex.scheduleGantt.floatPathLink": {
    "value": 2,
    "variable": "var(--bUkopf)"
  },
  "zIndex.scheduleGantt.criticalPathLink": {
    "value": 3,
    "variable": "var(--dvazQs)"
  },
  "zIndex.scheduleGantt.selectedLink": {
    "value": 4,
    "variable": "var(--AuQSv)"
  },
  "zIndex.scheduleGantt.barsLayer": {
    "value": 5,
    "variable": "var(--esOQIL)"
  },
  "zIndex.scheduleGantt.offDaysOverlay": {
    "value": 6,
    "variable": "var(--cDVChk)"
  },
  "zIndex.scheduleGantt.linkControls": {
    "value": 7,
    "variable": "var(--cslBRm)"
  },
  "zIndex.scheduleGantt.splitSeparator": {
    "value": 8,
    "variable": "var(--BjMZN)"
  },
  "zIndex.scheduleGantt.clippingIndicator": {
    "value": 12,
    "variable": "var(--hGhQuB)"
  },
  "zIndex.scheduleGantt.resizerRest": {
    "value": 13,
    "variable": "var(--sfRtq)"
  },
  "zIndex.scheduleGantt.ganttOptionsToolbar": {
    "value": 13,
    "variable": "var(--csGIpX)"
  },
  "zIndex.scheduleGantt.linkMenuPopup": {
    "value": 14,
    "variable": "var(--dxxuFj)"
  },
  "zIndex.scheduleGantt.resizerOverlay": {
    "value": 15,
    "variable": "var(--hFzdzs)"
  },
  "zIndex.scheduleGantt.resizerDragging": {
    "value": 16,
    "variable": "var(--heosjN)"
  },
  "breakpoints.sm": {
    "value": "40rem",
    "variable": "var(--ikokJA)"
  },
  "breakpoints.md": {
    "value": "48rem",
    "variable": "var(--kSvAmr)"
  },
  "breakpoints.lg": {
    "value": "64rem",
    "variable": "var(--uwdhN)"
  },
  "breakpoints.xl": {
    "value": "80rem",
    "variable": "var(--eyfDzy)"
  },
  "breakpoints.2xl": {
    "value": "96rem",
    "variable": "var(--dgHGKE)"
  },
  "colors.surface.neutral": {
    "value": "var(--dPEifN)",
    "variable": "var(--dPEifN)"
  },
  "colors.surface.neutral.subtle": {
    "value": "var(--fNCWHR)",
    "variable": "var(--fNCWHR)"
  },
  "colors.surface.neutral.subtlest": {
    "value": "var(--hAGoMG)",
    "variable": "var(--hAGoMG)"
  },
  "colors.surface.neutral.strong": {
    "value": "var(--iaTEeL)",
    "variable": "var(--iaTEeL)"
  },
  "colors.surface.neutral.strongest": {
    "value": "var(--dtHCEF)",
    "variable": "var(--dtHCEF)"
  },
  "colors.surface.neutral.overlay": {
    "value": "var(--hRjqoe)",
    "variable": "var(--hRjqoe)"
  },
  "colors.surface.neutral.action.subtlest": {
    "value": "var(--kAgOoZ)",
    "variable": "var(--kAgOoZ)"
  },
  "colors.surface.neutral.action.subtler": {
    "value": "var(--bQwlVI)",
    "variable": "var(--bQwlVI)"
  },
  "colors.surface.neutral.action.subtle": {
    "value": "var(--cbCHhq)",
    "variable": "var(--cbCHhq)"
  },
  "colors.surface.neutral.action.subtle.hover": {
    "value": "var(--bkrEEp)",
    "variable": "var(--bkrEEp)"
  },
  "colors.surface.neutral.action.subtle.press": {
    "value": "var(--cOqDoE)",
    "variable": "var(--cOqDoE)"
  },
  "colors.surface.neutral.action.subtle.active": {
    "value": "var(--kYWOEv)",
    "variable": "var(--kYWOEv)"
  },
  "colors.surface.neutral.action.subtle.disabled": {
    "value": "var(--dcwDGb)",
    "variable": "var(--dcwDGb)"
  },
  "colors.surface.neutral.action.strong": {
    "value": "var(--LYVIU)",
    "variable": "var(--LYVIU)"
  },
  "colors.surface.neutral.action.strong.hover": {
    "value": "var(--ignZKn)",
    "variable": "var(--ignZKn)"
  },
  "colors.surface.neutral.action.strong.press": {
    "value": "var(--hGrEaS)",
    "variable": "var(--hGrEaS)"
  },
  "colors.surface.neutral.action.strong.active": {
    "value": "var(--iFFHKh)",
    "variable": "var(--iFFHKh)"
  },
  "colors.surface.neutral.action.strong.disabled": {
    "value": "var(--gKZMYt)",
    "variable": "var(--gKZMYt)"
  },
  "colors.surface.brand.primary": {
    "value": "var(--cZxbnq)",
    "variable": "var(--cZxbnq)"
  },
  "colors.surface.brand.primary.hover": {
    "value": "var(--beQkVJ)",
    "variable": "var(--beQkVJ)"
  },
  "colors.surface.brand.primary.press": {
    "value": "var(--kxjwGU)",
    "variable": "var(--kxjwGU)"
  },
  "colors.surface.brand.primary.active": {
    "value": "var(--jehVAT)",
    "variable": "var(--jehVAT)"
  },
  "colors.surface.brand.primary.disabled": {
    "value": "var(--dlpIUH)",
    "variable": "var(--dlpIUH)"
  },
  "colors.surface.brand.primary.subtlest": {
    "value": "var(--gvFPwp)",
    "variable": "var(--gvFPwp)"
  },
  "colors.surface.brand.primary.subtler": {
    "value": "var(--gqEDlw)",
    "variable": "var(--gqEDlw)"
  },
  "colors.surface.brand.primary.subtle": {
    "value": "var(--bsjQbC)",
    "variable": "var(--bsjQbC)"
  },
  "colors.surface.brand.secondary.subtler": {
    "value": "var(--dWDzhy)",
    "variable": "var(--dWDzhy)"
  },
  "colors.surface.brand.secondary.subtle": {
    "value": "var(--dlYcLI)",
    "variable": "var(--dlYcLI)"
  },
  "colors.surface.brand.secondary": {
    "value": "var(--hfsFxw)",
    "variable": "var(--hfsFxw)"
  },
  "colors.surface.brand.secondary.strong": {
    "value": "var(--iRxuIK)",
    "variable": "var(--iRxuIK)"
  },
  "colors.surface.brand.secondary.stronger": {
    "value": "var(--dmxLQJ)",
    "variable": "var(--dmxLQJ)"
  },
  "colors.surface.brand.secondary.strongest": {
    "value": "var(--ftlwrA)",
    "variable": "var(--ftlwrA)"
  },
  "colors.surface.success": {
    "value": "var(--biXpIf)",
    "variable": "var(--biXpIf)"
  },
  "colors.surface.success.subtlest": {
    "value": "var(--goETFY)",
    "variable": "var(--goETFY)"
  },
  "colors.surface.success.subtler": {
    "value": "var(--jeETlV)",
    "variable": "var(--jeETlV)"
  },
  "colors.surface.success.subtle": {
    "value": "var(--cZVXHL)",
    "variable": "var(--cZVXHL)"
  },
  "colors.surface.success.hover": {
    "value": "var(--iRHSxQ)",
    "variable": "var(--iRHSxQ)"
  },
  "colors.surface.success.press": {
    "value": "var(--bmgGMF)",
    "variable": "var(--bmgGMF)"
  },
  "colors.surface.success.disabled": {
    "value": "var(--bAnLJu)",
    "variable": "var(--bAnLJu)"
  },
  "colors.surface.info.subtler": {
    "value": "var(--iuUBTc)",
    "variable": "var(--iuUBTc)"
  },
  "colors.surface.info.subtle": {
    "value": "var(--eMDrJy)",
    "variable": "var(--eMDrJy)"
  },
  "colors.surface.info": {
    "value": "var(--coDpUO)",
    "variable": "var(--coDpUO)"
  },
  "colors.surface.info.strong": {
    "value": "var(--juniE)",
    "variable": "var(--juniE)"
  },
  "colors.surface.info.stronger": {
    "value": "var(--JKMH)",
    "variable": "var(--JKMH)"
  },
  "colors.surface.warning": {
    "value": "var(--iGXXdi)",
    "variable": "var(--iGXXdi)"
  },
  "colors.surface.warning.subtlest": {
    "value": "var(--jCCAWh)",
    "variable": "var(--jCCAWh)"
  },
  "colors.surface.warning.subtle": {
    "value": "var(--dVluXm)",
    "variable": "var(--dVluXm)"
  },
  "colors.surface.warning.subtler": {
    "value": "var(--bUaPyI)",
    "variable": "var(--bUaPyI)"
  },
  "colors.surface.warning.hover": {
    "value": "var(--hWsvip)",
    "variable": "var(--hWsvip)"
  },
  "colors.surface.warning.press": {
    "value": "var(--hgmbds)",
    "variable": "var(--hgmbds)"
  },
  "colors.surface.warning.disabled": {
    "value": "var(--dLrPkr)",
    "variable": "var(--dLrPkr)"
  },
  "colors.surface.critical": {
    "value": "var(--cFWuPb)",
    "variable": "var(--cFWuPb)"
  },
  "colors.surface.critical.subtlest": {
    "value": "var(--eoObNQ)",
    "variable": "var(--eoObNQ)"
  },
  "colors.surface.critical.subtle": {
    "value": "var(--beuTDT)",
    "variable": "var(--beuTDT)"
  },
  "colors.surface.critical.subtler": {
    "value": "var(--bDmlad)",
    "variable": "var(--bDmlad)"
  },
  "colors.surface.critical.hover": {
    "value": "var(--NNNZY)",
    "variable": "var(--NNNZY)"
  },
  "colors.surface.critical.press": {
    "value": "var(--bFdlGV)",
    "variable": "var(--bFdlGV)"
  },
  "colors.surface.critical.disabled": {
    "value": "var(--eKFMTK)",
    "variable": "var(--eKFMTK)"
  },
  "colors.surface.custom.brown.subtle": {
    "value": "var(--gagvYA)",
    "variable": "var(--gagvYA)"
  },
  "colors.surface.custom.brown": {
    "value": "var(--cBbCkE)",
    "variable": "var(--cBbCkE)"
  },
  "colors.surface.custom.brown.strong": {
    "value": "var(--hyCGIW)",
    "variable": "var(--hyCGIW)"
  },
  "colors.surface.custom.cyan.subtle": {
    "value": "var(--igvOxv)",
    "variable": "var(--igvOxv)"
  },
  "colors.surface.custom.cyan": {
    "value": "var(--dsiqUD)",
    "variable": "var(--dsiqUD)"
  },
  "colors.surface.custom.cyan.strong": {
    "value": "var(--cXxvTx)",
    "variable": "var(--cXxvTx)"
  },
  "colors.surface.custom.fuchsia.subtle": {
    "value": "var(--pHkF)",
    "variable": "var(--pHkF)"
  },
  "colors.surface.custom.fuchsia": {
    "value": "var(--cjncBN)",
    "variable": "var(--cjncBN)"
  },
  "colors.surface.custom.fuchsia.strong": {
    "value": "var(--gODCNr)",
    "variable": "var(--gODCNr)"
  },
  "colors.surface.custom.lime.subtle": {
    "value": "var(--HODqP)",
    "variable": "var(--HODqP)"
  },
  "colors.surface.custom.lime": {
    "value": "var(--hImiGn)",
    "variable": "var(--hImiGn)"
  },
  "colors.surface.custom.lime.strong": {
    "value": "var(--dXiked)",
    "variable": "var(--dXiked)"
  },
  "colors.surface.custom.orange.subtle": {
    "value": "var(--kQvCae)",
    "variable": "var(--kQvCae)"
  },
  "colors.surface.custom.orange": {
    "value": "var(--bKhPrS)",
    "variable": "var(--bKhPrS)"
  },
  "colors.surface.custom.orange.strong": {
    "value": "var(--hIQddc)",
    "variable": "var(--hIQddc)"
  },
  "colors.surface.custom.pink.subtle": {
    "value": "var(--cZFMLe)",
    "variable": "var(--cZFMLe)"
  },
  "colors.surface.custom.pink": {
    "value": "var(--iidibO)",
    "variable": "var(--iidibO)"
  },
  "colors.surface.custom.pink.strong": {
    "value": "var(--dnDwuY)",
    "variable": "var(--dnDwuY)"
  },
  "colors.surface.custom.purple.subtle": {
    "value": "var(--sRLcc)",
    "variable": "var(--sRLcc)"
  },
  "colors.surface.custom.purple": {
    "value": "var(--caJCAg)",
    "variable": "var(--caJCAg)"
  },
  "colors.surface.custom.purple.strong": {
    "value": "var(--bIQSci)",
    "variable": "var(--bIQSci)"
  },
  "colors.surface.custom.rose.subtle": {
    "value": "var(--gFptSF)",
    "variable": "var(--gFptSF)"
  },
  "colors.surface.custom.rose": {
    "value": "var(--kaFAcd)",
    "variable": "var(--kaFAcd)"
  },
  "colors.surface.custom.rose.strong": {
    "value": "var(--fUTiXb)",
    "variable": "var(--fUTiXb)"
  },
  "colors.surface.custom.slate.subtle": {
    "value": "var(--fhCuCl)",
    "variable": "var(--fhCuCl)"
  },
  "colors.surface.custom.slate": {
    "value": "var(--bUbgyp)",
    "variable": "var(--bUbgyp)"
  },
  "colors.surface.custom.slate.strong": {
    "value": "var(--faGqhf)",
    "variable": "var(--faGqhf)"
  },
  "colors.surface.custom.teal.subtle": {
    "value": "var(--joPexC)",
    "variable": "var(--joPexC)"
  },
  "colors.surface.custom.teal": {
    "value": "var(--edFMLy)",
    "variable": "var(--edFMLy)"
  },
  "colors.surface.custom.teal.strong": {
    "value": "var(--cFGWjU)",
    "variable": "var(--cFGWjU)"
  },
  "colors.surface.custom.yellow.subtle": {
    "value": "var(--igDnlK)",
    "variable": "var(--igDnlK)"
  },
  "colors.surface.custom.yellow": {
    "value": "var(--hXxdvq)",
    "variable": "var(--hXxdvq)"
  },
  "colors.surface.custom.yellow.strong": {
    "value": "var(--kADWIs)",
    "variable": "var(--kADWIs)"
  },
  "colors.surface.manny.neon": {
    "value": "var(--dhtBSm)",
    "variable": "var(--dhtBSm)"
  },
  "colors.surface.manny.orange": {
    "value": "var(--kzQHJk)",
    "variable": "var(--kzQHJk)"
  },
  "colors.surface.manny.violet": {
    "value": "var(--eRAbQZ)",
    "variable": "var(--eRAbQZ)"
  },
  "colors.surface.manny.blue": {
    "value": "var(--jhihNC)",
    "variable": "var(--jhihNC)"
  },
  "colors.text.neutral": {
    "value": "var(--fCJfxh)",
    "variable": "var(--fCJfxh)"
  },
  "colors.text.neutral.subtle": {
    "value": "var(--dKXXUp)",
    "variable": "var(--dKXXUp)"
  },
  "colors.text.neutral.subtlest": {
    "value": "var(--dbGTde)",
    "variable": "var(--dbGTde)"
  },
  "colors.text.neutral.onFill": {
    "value": "var(--sYgRe)",
    "variable": "var(--sYgRe)"
  },
  "colors.text.neutral.disabled": {
    "value": "var(--gmMgWE)",
    "variable": "var(--gmMgWE)"
  },
  "colors.text.neutral.action": {
    "value": "var(--eQSbUi)",
    "variable": "var(--eQSbUi)"
  },
  "colors.text.neutral.action.dark": {
    "value": "var(--ijfuMP)",
    "variable": "var(--ijfuMP)"
  },
  "colors.text.neutral.action.subtle": {
    "value": "var(--eIOTJy)",
    "variable": "var(--eIOTJy)"
  },
  "colors.text.neutral.action.disabled": {
    "value": "var(--cKMhUL)",
    "variable": "var(--cKMhUL)"
  },
  "colors.text.neutral.action.onFill": {
    "value": "var(--enFhUR)",
    "variable": "var(--enFhUR)"
  },
  "colors.text.brand.primary": {
    "value": "var(--fsHwIe)",
    "variable": "var(--fsHwIe)"
  },
  "colors.text.brand.primary.dark": {
    "value": "var(--hIMJTP)",
    "variable": "var(--hIMJTP)"
  },
  "colors.text.brand.primary.disabled": {
    "value": "var(--bxmRTD)",
    "variable": "var(--bxmRTD)"
  },
  "colors.text.brand.primary.subtle": {
    "value": "var(--TGRlm)",
    "variable": "var(--TGRlm)"
  },
  "colors.text.brand.secondary": {
    "value": "var(--cXnRqk)",
    "variable": "var(--cXnRqk)"
  },
  "colors.text.brand.secondary.dark": {
    "value": "var(--bRLVwJ)",
    "variable": "var(--bRLVwJ)"
  },
  "colors.text.brand.secondary.disabled": {
    "value": "var(--klVGmx)",
    "variable": "var(--klVGmx)"
  },
  "colors.text.brand.secondary.subtle": {
    "value": "var(--fTReDQ)",
    "variable": "var(--fTReDQ)"
  },
  "colors.text.success": {
    "value": "var(--huxSpP)",
    "variable": "var(--huxSpP)"
  },
  "colors.text.success.dark": {
    "value": "var(--hEvRKe)",
    "variable": "var(--hEvRKe)"
  },
  "colors.text.success.subtle": {
    "value": "var(--hUeCiH)",
    "variable": "var(--hUeCiH)"
  },
  "colors.text.success.disabled": {
    "value": "var(--ifgyWi)",
    "variable": "var(--ifgyWi)"
  },
  "colors.text.info": {
    "value": "var(--jkCEwG)",
    "variable": "var(--jkCEwG)"
  },
  "colors.text.warning": {
    "value": "var(--ijzQoe)",
    "variable": "var(--ijzQoe)"
  },
  "colors.text.warning.dark": {
    "value": "var(--jEJOfj)",
    "variable": "var(--jEJOfj)"
  },
  "colors.text.warning.disabled": {
    "value": "var(--krwEHT)",
    "variable": "var(--krwEHT)"
  },
  "colors.text.warning.subtle": {
    "value": "var(--jlEyXu)",
    "variable": "var(--jlEyXu)"
  },
  "colors.text.critical": {
    "value": "var(--eSdFZX)",
    "variable": "var(--eSdFZX)"
  },
  "colors.text.critical.dark": {
    "value": "var(--chyRUK)",
    "variable": "var(--chyRUK)"
  },
  "colors.text.critical.disabled": {
    "value": "var(--iOhRJu)",
    "variable": "var(--iOhRJu)"
  },
  "colors.text.critical.subtle": {
    "value": "var(--fiedVn)",
    "variable": "var(--fiedVn)"
  },
  "colors.stroke.neutral.subtle": {
    "value": "var(--dkdZhI)",
    "variable": "var(--dkdZhI)"
  },
  "colors.stroke.neutral": {
    "value": "var(--eXfSII)",
    "variable": "var(--eXfSII)"
  },
  "colors.stroke.neutral.strong": {
    "value": "var(--gDhTZi)",
    "variable": "var(--gDhTZi)"
  },
  "colors.stroke.neutral.action": {
    "value": "var(--iQDSpT)",
    "variable": "var(--iQDSpT)"
  },
  "colors.stroke.neutral.action.press": {
    "value": "var(--isUTQB)",
    "variable": "var(--isUTQB)"
  },
  "colors.stroke.neutral.action.disabled": {
    "value": "var(--lfZYli)",
    "variable": "var(--lfZYli)"
  },
  "colors.stroke.neutral.action.focus": {
    "value": "var(--jAgnPu)",
    "variable": "var(--jAgnPu)"
  },
  "colors.stroke.brand.primary.subtle": {
    "value": "var(--kMxjHT)",
    "variable": "var(--kMxjHT)"
  },
  "colors.stroke.brand.primary": {
    "value": "var(--dOJbmf)",
    "variable": "var(--dOJbmf)"
  },
  "colors.stroke.brand.primary.strong": {
    "value": "var(--ubwSR)",
    "variable": "var(--ubwSR)"
  },
  "colors.stroke.brand.primary.hover": {
    "value": "var(--WrlZI)",
    "variable": "var(--WrlZI)"
  },
  "colors.stroke.brand.primary.disabled": {
    "value": "var(--WNQKi)",
    "variable": "var(--WNQKi)"
  },
  "colors.stroke.brand.primary.focus": {
    "value": "var(--eLJYbq)",
    "variable": "var(--eLJYbq)"
  },
  "colors.stroke.brand.secondary.subtle": {
    "value": "var(--hnneYF)",
    "variable": "var(--hnneYF)"
  },
  "colors.stroke.brand.secondary": {
    "value": "var(--fFfgsR)",
    "variable": "var(--fFfgsR)"
  },
  "colors.stroke.brand.secondary.strong": {
    "value": "var(--bofXeT)",
    "variable": "var(--bofXeT)"
  },
  "colors.stroke.success.subtle": {
    "value": "var(--eAmdXK)",
    "variable": "var(--eAmdXK)"
  },
  "colors.stroke.success": {
    "value": "var(--jhuWDy)",
    "variable": "var(--jhuWDy)"
  },
  "colors.stroke.success.strong": {
    "value": "var(--fyTiro)",
    "variable": "var(--fyTiro)"
  },
  "colors.stroke.success.hover": {
    "value": "var(--HIJkF)",
    "variable": "var(--HIJkF)"
  },
  "colors.stroke.success.disabled": {
    "value": "var(--eJwsZf)",
    "variable": "var(--eJwsZf)"
  },
  "colors.stroke.success.focus": {
    "value": "var(--ikBjz)",
    "variable": "var(--ikBjz)"
  },
  "colors.stroke.info.subtle": {
    "value": "var(--jqmHfX)",
    "variable": "var(--jqmHfX)"
  },
  "colors.stroke.info": {
    "value": "var(--fYKHkz)",
    "variable": "var(--fYKHkz)"
  },
  "colors.stroke.info.strong": {
    "value": "var(--jucsKF)",
    "variable": "var(--jucsKF)"
  },
  "colors.stroke.warning.subtle": {
    "value": "var(--ccyJcP)",
    "variable": "var(--ccyJcP)"
  },
  "colors.stroke.warning": {
    "value": "var(--cxEKpP)",
    "variable": "var(--cxEKpP)"
  },
  "colors.stroke.warning.strong": {
    "value": "var(--kAwqvh)",
    "variable": "var(--kAwqvh)"
  },
  "colors.stroke.warning.hover": {
    "value": "var(--dfwefA)",
    "variable": "var(--dfwefA)"
  },
  "colors.stroke.warning.disabled": {
    "value": "var(--eviDJC)",
    "variable": "var(--eviDJC)"
  },
  "colors.stroke.warning.focus": {
    "value": "var(--bowamK)",
    "variable": "var(--bowamK)"
  },
  "colors.stroke.critical.subtle": {
    "value": "var(--hsEBMy)",
    "variable": "var(--hsEBMy)"
  },
  "colors.stroke.critical": {
    "value": "var(--ljRXLG)",
    "variable": "var(--ljRXLG)"
  },
  "colors.stroke.critical.strong": {
    "value": "var(--jtYOsI)",
    "variable": "var(--jtYOsI)"
  },
  "colors.stroke.critical.hover": {
    "value": "var(--eyZotd)",
    "variable": "var(--eyZotd)"
  },
  "colors.stroke.critical.disabled": {
    "value": "var(--kQQnVn)",
    "variable": "var(--kQQnVn)"
  },
  "colors.stroke.critical.focus": {
    "value": "var(--hXIkKf)",
    "variable": "var(--hXIkKf)"
  },
  "colors.stroke.custom.brown.subtle": {
    "value": "var(--dtgkNh)",
    "variable": "var(--dtgkNh)"
  },
  "colors.stroke.custom.brown": {
    "value": "var(--bJgKih)",
    "variable": "var(--bJgKih)"
  },
  "colors.stroke.custom.brown.strong": {
    "value": "var(--kRqNvL)",
    "variable": "var(--kRqNvL)"
  },
  "colors.stroke.custom.cyan.subtle": {
    "value": "var(--jBpoiG)",
    "variable": "var(--jBpoiG)"
  },
  "colors.stroke.custom.cyan": {
    "value": "var(--gjjDLa)",
    "variable": "var(--gjjDLa)"
  },
  "colors.stroke.custom.cyan.strong": {
    "value": "var(--jzGJnw)",
    "variable": "var(--jzGJnw)"
  },
  "colors.stroke.custom.fuchsia.subtle": {
    "value": "var(--vKAiw)",
    "variable": "var(--vKAiw)"
  },
  "colors.stroke.custom.fuchsia": {
    "value": "var(--etonvo)",
    "variable": "var(--etonvo)"
  },
  "colors.stroke.custom.fuchsia.strong": {
    "value": "var(--dWGkIu)",
    "variable": "var(--dWGkIu)"
  },
  "colors.stroke.custom.lime.subtle": {
    "value": "var(--fBAYMa)",
    "variable": "var(--fBAYMa)"
  },
  "colors.stroke.custom.lime": {
    "value": "var(--bwatq)",
    "variable": "var(--bwatq)"
  },
  "colors.stroke.custom.lime.strong": {
    "value": "var(--bSyqsQ)",
    "variable": "var(--bSyqsQ)"
  },
  "colors.stroke.custom.orange.subtle": {
    "value": "var(--gvFKsD)",
    "variable": "var(--gvFKsD)"
  },
  "colors.stroke.custom.orange": {
    "value": "var(--cBQopf)",
    "variable": "var(--cBQopf)"
  },
  "colors.stroke.custom.orange.strong": {
    "value": "var(--boyyiV)",
    "variable": "var(--boyyiV)"
  },
  "colors.stroke.custom.pink.subtle": {
    "value": "var(--ibJjAr)",
    "variable": "var(--ibJjAr)"
  },
  "colors.stroke.custom.pink": {
    "value": "var(--iAwQYv)",
    "variable": "var(--iAwQYv)"
  },
  "colors.stroke.custom.pink.strong": {
    "value": "var(--dXLfph)",
    "variable": "var(--dXLfph)"
  },
  "colors.stroke.custom.purple.subtle": {
    "value": "var(--dpNLwZ)",
    "variable": "var(--dpNLwZ)"
  },
  "colors.stroke.custom.purple": {
    "value": "var(--disNoh)",
    "variable": "var(--disNoh)"
  },
  "colors.stroke.custom.purple.strong": {
    "value": "var(--cTBZiH)",
    "variable": "var(--cTBZiH)"
  },
  "colors.stroke.custom.rose.subtle": {
    "value": "var(--hAMvkg)",
    "variable": "var(--hAMvkg)"
  },
  "colors.stroke.custom.rose": {
    "value": "var(--hZNePw)",
    "variable": "var(--hZNePw)"
  },
  "colors.stroke.custom.rose.strong": {
    "value": "var(--kzaJpy)",
    "variable": "var(--kzaJpy)"
  },
  "colors.stroke.custom.slate.subtle": {
    "value": "var(--dqkblo)",
    "variable": "var(--dqkblo)"
  },
  "colors.stroke.custom.slate": {
    "value": "var(--dwJOjA)",
    "variable": "var(--dwJOjA)"
  },
  "colors.stroke.custom.slate.strong": {
    "value": "var(--fRsJKq)",
    "variable": "var(--fRsJKq)"
  },
  "colors.stroke.custom.teal.subtle": {
    "value": "var(--fZLDPL)",
    "variable": "var(--fZLDPL)"
  },
  "colors.stroke.custom.teal": {
    "value": "var(--duuHfP)",
    "variable": "var(--duuHfP)"
  },
  "colors.stroke.custom.teal.strong": {
    "value": "var(--fEPagl)",
    "variable": "var(--fEPagl)"
  },
  "colors.stroke.custom.yellow.subtle": {
    "value": "var(--fgCFZL)",
    "variable": "var(--fgCFZL)"
  },
  "colors.stroke.custom.yellow": {
    "value": "var(--QGAqL)",
    "variable": "var(--QGAqL)"
  },
  "colors.stroke.custom.yellow.strong": {
    "value": "var(--jSKOZF)",
    "variable": "var(--jSKOZF)"
  },
  "colors.icon.brand.primary": {
    "value": "var(--jcFeGA)",
    "variable": "var(--jcFeGA)"
  },
  "colors.icon.brand.primary.dark": {
    "value": "var(--jMPVpV)",
    "variable": "var(--jMPVpV)"
  },
  "colors.icon.brand.secondary": {
    "value": "var(--gfWBjO)",
    "variable": "var(--gfWBjO)"
  },
  "colors.icon.brand.secondary.dark": {
    "value": "var(--krWNX)",
    "variable": "var(--krWNX)"
  },
  "colors.icon.success": {
    "value": "var(--hTeUqd)",
    "variable": "var(--hTeUqd)"
  },
  "colors.icon.success.dark": {
    "value": "var(--flIqlw)",
    "variable": "var(--flIqlw)"
  },
  "colors.icon.info": {
    "value": "var(--dIVKhc)",
    "variable": "var(--dIVKhc)"
  },
  "colors.icon.info.dark": {
    "value": "var(--dZABRt)",
    "variable": "var(--dZABRt)"
  },
  "colors.icon.warning": {
    "value": "var(--csBOUs)",
    "variable": "var(--csBOUs)"
  },
  "colors.icon.warning.dark": {
    "value": "var(--eNPacZ)",
    "variable": "var(--eNPacZ)"
  },
  "colors.icon.critical": {
    "value": "var(--NvFUJ)",
    "variable": "var(--NvFUJ)"
  },
  "colors.icon.critical.dark": {
    "value": "var(--jfrmdE)",
    "variable": "var(--jfrmdE)"
  },
  "colors.icon.disabled.brand.primary": {
    "value": "var(--lcYvYp)",
    "variable": "var(--lcYvYp)"
  },
  "colors.icon.disabled.brand.secondary": {
    "value": "var(--eVCxf)",
    "variable": "var(--eVCxf)"
  },
  "colors.icon.disabled.success": {
    "value": "var(--eMSmlI)",
    "variable": "var(--eMSmlI)"
  },
  "colors.icon.disabled.warning": {
    "value": "var(--bdZtfd)",
    "variable": "var(--bdZtfd)"
  },
  "colors.icon.disabled.critical": {
    "value": "var(--muWko)",
    "variable": "var(--muWko)"
  },
  "colors.icon.neutral": {
    "value": "var(--iyEiTX)",
    "variable": "var(--iyEiTX)"
  },
  "colors.icon.neutral.subtle": {
    "value": "var(--bXqISr)",
    "variable": "var(--bXqISr)"
  },
  "colors.icon.neutral.subtler": {
    "value": "var(--eHKiyt)",
    "variable": "var(--eHKiyt)"
  },
  "colors.icon.neutral.subtlest": {
    "value": "var(--cdpaTc)",
    "variable": "var(--cdpaTc)"
  },
  "colors.icon.neutral.onFill": {
    "value": "var(--bmSOYo)",
    "variable": "var(--bmSOYo)"
  },
  "colors.icon.neutral.disabled": {
    "value": "var(--iNlVyy)",
    "variable": "var(--iNlVyy)"
  },
  "colors.icon.custom.brown": {
    "value": "var(--ecCiHe)",
    "variable": "var(--ecCiHe)"
  },
  "colors.icon.custom.cyan": {
    "value": "var(--dFcYLN)",
    "variable": "var(--dFcYLN)"
  },
  "colors.icon.custom.fuchsia": {
    "value": "var(--btnjaT)",
    "variable": "var(--btnjaT)"
  },
  "colors.icon.custom.lime": {
    "value": "var(--jMZjWJ)",
    "variable": "var(--jMZjWJ)"
  },
  "colors.icon.custom.orange": {
    "value": "var(--fSTvNY)",
    "variable": "var(--fSTvNY)"
  },
  "colors.icon.custom.pink": {
    "value": "var(--ibCDVM)",
    "variable": "var(--ibCDVM)"
  },
  "colors.icon.custom.purple": {
    "value": "var(--cfOqki)",
    "variable": "var(--cfOqki)"
  },
  "colors.icon.custom.rose": {
    "value": "var(--gnDODr)",
    "variable": "var(--gnDODr)"
  },
  "colors.icon.custom.slate": {
    "value": "var(--kBfCX)",
    "variable": "var(--kBfCX)"
  },
  "colors.icon.custom.teal": {
    "value": "var(--fhIfyY)",
    "variable": "var(--fhIfyY)"
  },
  "colors.icon.custom.yellow": {
    "value": "var(--kFWlng)",
    "variable": "var(--kFWlng)"
  },
  "colors.shadow.xs": {
    "value": "var(--cglRlA)",
    "variable": "var(--cglRlA)"
  },
  "colors.shadow.sm": {
    "value": "var(--jVpJol)",
    "variable": "var(--jVpJol)"
  },
  "colors.shadow.md": {
    "value": "var(--fQoWgS)",
    "variable": "var(--fQoWgS)"
  },
  "colors.shadow.lg": {
    "value": "var(--ljFrmg)",
    "variable": "var(--ljFrmg)"
  },
  "colors.shadow.xl": {
    "value": "var(--eSqzdn)",
    "variable": "var(--eSqzdn)"
  },
  "colors.shadow.inverted.xs": {
    "value": "var(--SfrEW)",
    "variable": "var(--SfrEW)"
  },
  "colors.shadow.inverted.sm": {
    "value": "var(--iUtXvz)",
    "variable": "var(--iUtXvz)"
  },
  "colors.shadow.inverted.md": {
    "value": "var(--cJFoBE)",
    "variable": "var(--cJFoBE)"
  },
  "colors.shadow.inverted.lg": {
    "value": "var(--iZeAoG)",
    "variable": "var(--iZeAoG)"
  },
  "colors.shadow.inverted.xl": {
    "value": "var(--hzgTEF)",
    "variable": "var(--hzgTEF)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--dzOvWn)"
  },
  "borders.separator": {
    "value": "var(--cjTwZZ) solid var(--gDhTZi)",
    "variable": "var(--bDUjHg)"
  },
  "borders.separator.subtle": {
    "value": "var(--cjTwZZ) solid var(--eXfSII)",
    "variable": "var(--dcejYg)"
  },
  "borders.surface": {
    "value": "var(--cjTwZZ) solid var(--eXfSII)",
    "variable": "var(--jNcFxM)"
  },
  "borders.toolbar": {
    "value": "var(--cjTwZZ) solid var(--gDhTZi)",
    "variable": "var(--iZtsTA)"
  },
  "borders.secondary": {
    "value": "var(--cjTwZZ) solid var(--iQDSpT)",
    "variable": "var(--jfZOmD)"
  },
  "borders.secondary.press": {
    "value": "var(--cjTwZZ) solid var(--isUTQB)",
    "variable": "var(--dpAecF)"
  },
  "borders.secondary.disabled": {
    "value": "var(--cjTwZZ) solid var(--lfZYli)",
    "variable": "var(--cosVYy)"
  },
  "borders.input": {
    "value": "var(--cjTwZZ) solid var(--iQDSpT)",
    "variable": "var(--gziQbn)"
  },
  "borders.input.hover": {
    "value": "var(--cjTwZZ) solid var(--dOJbmf)",
    "variable": "var(--hwLUOk)"
  },
  "borders.input.active": {
    "value": "var(--cjTwZZ) solid var(--ubwSR)",
    "variable": "var(--eEPMDC)"
  },
  "borders.input.disabled": {
    "value": "var(--cjTwZZ) solid var(--lfZYli)",
    "variable": "var(--cGCJha)"
  },
  "borders.input.error": {
    "value": "var(--cjTwZZ) solid var(--ljRXLG)",
    "variable": "var(--hVrhrq)"
  },
  "borders.focus.brand": {
    "value": "var(--jBUvqk) solid var(--eLJYbq)",
    "variable": "var(--dOFcHz)"
  },
  "borders.focus.warning": {
    "value": "var(--jBUvqk) solid var(--bowamK)",
    "variable": "var(--bXryZa)"
  },
  "borders.focus.critical": {
    "value": "var(--jBUvqk) solid var(--hXIkKf)",
    "variable": "var(--dVtYUL)"
  },
  "borders.focus.neutral": {
    "value": "var(--jBUvqk) solid var(--jAgnPu)",
    "variable": "var(--gasKzp)"
  },
  "borders.element": {
    "value": "var(--cjTwZZ) solid var(--eXfSII)",
    "variable": "var(--iSfagX)"
  },
  "borders.element.hover": {
    "value": "var(--hRTFLr) solid var(--dOJbmf)",
    "variable": "var(--bdHVHE)"
  },
  "borders.element.active": {
    "value": "var(--dvTIcW) solid var(--dOJbmf)",
    "variable": "var(--gpwFIq)"
  },
  "animations.accordion-down": {
    "value": "accordion-down 0.2s ease-out",
    "variable": "var(--jUUAKY)"
  },
  "animations.accordion-up": {
    "value": "accordion-up 0.2s ease-out",
    "variable": "var(--eqjWfX)"
  },
  "animations.fade-in": {
    "value": "fade-in 0.15s ease-out",
    "variable": "var(--cmlixv)"
  },
  "animations.fade-out": {
    "value": "fade-out 0.15s ease-out",
    "variable": "var(--bSjUIG)"
  },
  "animations.slide-in-right": {
    "value": "slide-in-right 0.3s ease-out",
    "variable": "var(--jCNQZb)"
  },
  "animations.slide-out-right": {
    "value": "slide-out-right 0.3s ease-out",
    "variable": "var(--rLPli)"
  },
  "animations.popup-slide-in": {
    "value": "popup-slide-in 0.15s ease-out",
    "variable": "var(--ggRQlB)"
  },
  "animations.popup-slide-out": {
    "value": "popup-slide-out 0.1s ease-in",
    "variable": "var(--cJFrxc)"
  },
  "spacing.-px": {
    "value": "calc(var(--dnyzTn) * -1)",
    "variable": "var(--dnyzTn)"
  },
  "spacing.-5xs": {
    "value": "calc(var(--eySuft) * -1)",
    "variable": "var(--eySuft)"
  },
  "spacing.-4xs": {
    "value": "calc(var(--cwbymM) * -1)",
    "variable": "var(--cwbymM)"
  },
  "spacing.-3xs": {
    "value": "calc(var(--cVdxOb) * -1)",
    "variable": "var(--cVdxOb)"
  },
  "spacing.-2xs": {
    "value": "calc(var(--SmBVu) * -1)",
    "variable": "var(--SmBVu)"
  },
  "spacing.-xs": {
    "value": "calc(var(--icrUDE) * -1)",
    "variable": "var(--icrUDE)"
  },
  "spacing.-sm": {
    "value": "calc(var(--jolVMp) * -1)",
    "variable": "var(--jolVMp)"
  },
  "spacing.-md": {
    "value": "calc(var(--eEeglK) * -1)",
    "variable": "var(--eEeglK)"
  },
  "spacing.-base": {
    "value": "calc(var(--gViRqS) * -1)",
    "variable": "var(--gViRqS)"
  },
  "spacing.-lg": {
    "value": "calc(var(--fFUZAQ) * -1)",
    "variable": "var(--fFUZAQ)"
  },
  "spacing.-xl": {
    "value": "calc(var(--gvVjyT) * -1)",
    "variable": "var(--gvVjyT)"
  },
  "spacing.-2xl": {
    "value": "calc(var(--ceCtBJ) * -1)",
    "variable": "var(--ceCtBJ)"
  },
  "spacing.-3xl": {
    "value": "calc(var(--bLxJc) * -1)",
    "variable": "var(--bLxJc)"
  },
  "spacing.-4xl": {
    "value": "calc(var(--ANxkr) * -1)",
    "variable": "var(--ANxkr)"
  },
  "spacing.-5xl": {
    "value": "calc(var(--jNskQG) * -1)",
    "variable": "var(--jNskQG)"
  },
  "spacing.-6xl": {
    "value": "calc(var(--kOJKJV) * -1)",
    "variable": "var(--kOJKJV)"
  },
  "spacing.-7xl": {
    "value": "calc(var(--iLSORo) * -1)",
    "variable": "var(--iLSORo)"
  },
  "spacing.-8xl": {
    "value": "calc(var(--dpgZwD) * -1)",
    "variable": "var(--dpgZwD)"
  },
  "spacing.-9xl": {
    "value": "calc(var(--bmqdDW) * -1)",
    "variable": "var(--bmqdDW)"
  },
  "spacing.-10xl": {
    "value": "calc(var(--loYIla) * -1)",
    "variable": "var(--loYIla)"
  },
  "spacing.-11xl": {
    "value": "calc(var(--fLRwFr) * -1)",
    "variable": "var(--fLRwFr)"
  },
  "spacing.-12xl": {
    "value": "calc(var(--dEKpsg) * -1)",
    "variable": "var(--dEKpsg)"
  },
  "spacing.-13xl": {
    "value": "calc(var(--jqYNlt) * -1)",
    "variable": "var(--jqYNlt)"
  },
  "spacing.-14xl": {
    "value": "calc(var(--hcMAW) * -1)",
    "variable": "var(--hcMAW)"
  },
  "spacing.-15xl": {
    "value": "calc(var(--fTrkuj) * -1)",
    "variable": "var(--fTrkuj)"
  },
  "spacing.-16xl": {
    "value": "calc(var(--dMkdgY) * -1)",
    "variable": "var(--dMkdgY)"
  },
  "spacing.-17xl": {
    "value": "calc(var(--jyyBal) * -1)",
    "variable": "var(--jyyBal)"
  },
  "spacing.-18xl": {
    "value": "calc(var(--fIkuSK) * -1)",
    "variable": "var(--fIkuSK)"
  },
  "spacing.-19xl": {
    "value": "calc(var(--fdjnb) * -1)",
    "variable": "var(--fdjnb)"
  },
  "spacing.-20xl": {
    "value": "calc(var(--aUyFt) * -1)",
    "variable": "var(--aUyFt)"
  },
  "spacing.-21xl": {
    "value": "calc(var(--hmVpc) * -1)",
    "variable": "var(--hmVpc)"
  },
  "spacing.-22xl": {
    "value": "calc(var(--izoUL) * -1)",
    "variable": "var(--izoUL)"
  },
  "spacing.-23xl": {
    "value": "calc(var(--kEnvdq) * -1)",
    "variable": "var(--kEnvdq)"
  },
  "spacing.-24xl": {
    "value": "calc(var(--biumul) * -1)",
    "variable": "var(--biumul)"
  },
  "spacing.-25xl": {
    "value": "calc(var(--oMJdU) * -1)",
    "variable": "var(--oMJdU)"
  },
  "spacing.-26xl": {
    "value": "calc(var(--pZcJD) * -1)",
    "variable": "var(--pZcJD)"
  },
  "colors.colorPalette.50": {
    "value": "var(--bgowFI)",
    "variable": "var(--bgowFI)"
  },
  "colors.colorPalette.100": {
    "value": "var(--iSScQY)",
    "variable": "var(--iSScQY)"
  },
  "colors.colorPalette.200": {
    "value": "var(--bdPmBD)",
    "variable": "var(--bdPmBD)"
  },
  "colors.colorPalette.300": {
    "value": "var(--EuecW)",
    "variable": "var(--EuecW)"
  },
  "colors.colorPalette.400": {
    "value": "var(--dIdJaV)",
    "variable": "var(--dIdJaV)"
  },
  "colors.colorPalette.500": {
    "value": "var(--iOGEjQ)",
    "variable": "var(--iOGEjQ)"
  },
  "colors.colorPalette.600": {
    "value": "var(--ZDNUv)",
    "variable": "var(--ZDNUv)"
  },
  "colors.colorPalette.700": {
    "value": "var(--AiFvO)",
    "variable": "var(--AiFvO)"
  },
  "colors.colorPalette.800": {
    "value": "var(--iCIPjV)",
    "variable": "var(--iCIPjV)"
  },
  "colors.colorPalette.900": {
    "value": "var(--ctQaTU)",
    "variable": "var(--ctQaTU)"
  },
  "colors.colorPalette": {
    "value": "var(--idUrcU)",
    "variable": "var(--idUrcU)"
  },
  "colors.colorPalette.gridIconHoverBg": {
    "value": "var(--UewCl)",
    "variable": "var(--UewCl)"
  },
  "colors.colorPalette.neon": {
    "value": "var(--iuGHiX)",
    "variable": "var(--iuGHiX)"
  },
  "colors.colorPalette.orange": {
    "value": "var(--gQvpTN)",
    "variable": "var(--gQvpTN)"
  },
  "colors.colorPalette.blue": {
    "value": "var(--jemEav)",
    "variable": "var(--jemEav)"
  },
  "colors.colorPalette.violet": {
    "value": "var(--fHceDc)",
    "variable": "var(--fHceDc)"
  },
  "colors.colorPalette.neutral": {
    "value": "var(--hXmFow)",
    "variable": "var(--hXmFow)"
  },
  "colors.colorPalette.neutral.subtle": {
    "value": "var(--fWMyos)",
    "variable": "var(--fWMyos)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--gXkkLU)",
    "variable": "var(--gXkkLU)"
  },
  "colors.colorPalette.neutral.subtlest": {
    "value": "var(--gejhnz)",
    "variable": "var(--gejhnz)"
  },
  "colors.colorPalette.subtlest": {
    "value": "var(--cZAMYn)",
    "variable": "var(--cZAMYn)"
  },
  "colors.colorPalette.neutral.strong": {
    "value": "var(--gxltma)",
    "variable": "var(--gxltma)"
  },
  "colors.colorPalette.strong": {
    "value": "var(--fySWgG)",
    "variable": "var(--fySWgG)"
  },
  "colors.colorPalette.neutral.strongest": {
    "value": "var(--iZkoUk)",
    "variable": "var(--iZkoUk)"
  },
  "colors.colorPalette.strongest": {
    "value": "var(--csAkuk)",
    "variable": "var(--csAkuk)"
  },
  "colors.colorPalette.neutral.overlay": {
    "value": "var(--hMeInf)",
    "variable": "var(--hMeInf)"
  },
  "colors.colorPalette.overlay": {
    "value": "var(--kAiMLn)",
    "variable": "var(--kAiMLn)"
  },
  "colors.colorPalette.neutral.action.subtlest": {
    "value": "var(--dWHhfk)",
    "variable": "var(--dWHhfk)"
  },
  "colors.colorPalette.action.subtlest": {
    "value": "var(--dkPbiw)",
    "variable": "var(--dkPbiw)"
  },
  "colors.colorPalette.neutral.action.subtler": {
    "value": "var(--gsALSl)",
    "variable": "var(--gsALSl)"
  },
  "colors.colorPalette.action.subtler": {
    "value": "var(--iOpLUl)",
    "variable": "var(--iOpLUl)"
  },
  "colors.colorPalette.subtler": {
    "value": "var(--fpKiaa)",
    "variable": "var(--fpKiaa)"
  },
  "colors.colorPalette.neutral.action.subtle": {
    "value": "var(--gTcqYX)",
    "variable": "var(--gTcqYX)"
  },
  "colors.colorPalette.action.subtle": {
    "value": "var(--fHdUOH)",
    "variable": "var(--fHdUOH)"
  },
  "colors.colorPalette.neutral.action.subtle.hover": {
    "value": "var(--gKibyc)",
    "variable": "var(--gKibyc)"
  },
  "colors.colorPalette.action.subtle.hover": {
    "value": "var(--kwDhXM)",
    "variable": "var(--kwDhXM)"
  },
  "colors.colorPalette.subtle.hover": {
    "value": "var(--fjQNDf)",
    "variable": "var(--fjQNDf)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--hjJRhX)",
    "variable": "var(--hjJRhX)"
  },
  "colors.colorPalette.neutral.action.subtle.press": {
    "value": "var(--jOzOBx)",
    "variable": "var(--jOzOBx)"
  },
  "colors.colorPalette.action.subtle.press": {
    "value": "var(--eMRnel)",
    "variable": "var(--eMRnel)"
  },
  "colors.colorPalette.subtle.press": {
    "value": "var(--iMpeBC)",
    "variable": "var(--iMpeBC)"
  },
  "colors.colorPalette.press": {
    "value": "var(--hMRYFa)",
    "variable": "var(--hMRYFa)"
  },
  "colors.colorPalette.neutral.action.subtle.active": {
    "value": "var(--kwxWsW)",
    "variable": "var(--kwxWsW)"
  },
  "colors.colorPalette.action.subtle.active": {
    "value": "var(--fqAfLm)",
    "variable": "var(--fqAfLm)"
  },
  "colors.colorPalette.subtle.active": {
    "value": "var(--dUEWWZ)",
    "variable": "var(--dUEWWZ)"
  },
  "colors.colorPalette.active": {
    "value": "var(--iaREDJ)",
    "variable": "var(--iaREDJ)"
  },
  "colors.colorPalette.neutral.action.subtle.disabled": {
    "value": "var(--dcPvIS)",
    "variable": "var(--dcPvIS)"
  },
  "colors.colorPalette.action.subtle.disabled": {
    "value": "var(--NMOku)",
    "variable": "var(--NMOku)"
  },
  "colors.colorPalette.subtle.disabled": {
    "value": "var(--eYailt)",
    "variable": "var(--eYailt)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--gTYnIJ)",
    "variable": "var(--gTYnIJ)"
  },
  "colors.colorPalette.neutral.action.strong": {
    "value": "var(--kQrNAB)",
    "variable": "var(--kQrNAB)"
  },
  "colors.colorPalette.action.strong": {
    "value": "var(--coOqwZ)",
    "variable": "var(--coOqwZ)"
  },
  "colors.colorPalette.neutral.action.strong.hover": {
    "value": "var(--eKMflS)",
    "variable": "var(--eKMflS)"
  },
  "colors.colorPalette.action.strong.hover": {
    "value": "var(--ieTVsO)",
    "variable": "var(--ieTVsO)"
  },
  "colors.colorPalette.strong.hover": {
    "value": "var(--KNEJx)",
    "variable": "var(--KNEJx)"
  },
  "colors.colorPalette.neutral.action.strong.press": {
    "value": "var(--iqHgoH)",
    "variable": "var(--iqHgoH)"
  },
  "colors.colorPalette.action.strong.press": {
    "value": "var(--kXZiWH)",
    "variable": "var(--kXZiWH)"
  },
  "colors.colorPalette.strong.press": {
    "value": "var(--eBmoJw)",
    "variable": "var(--eBmoJw)"
  },
  "colors.colorPalette.neutral.action.strong.active": {
    "value": "var(--kiTfTE)",
    "variable": "var(--kiTfTE)"
  },
  "colors.colorPalette.action.strong.active": {
    "value": "var(--jiQCgY)",
    "variable": "var(--jiQCgY)"
  },
  "colors.colorPalette.strong.active": {
    "value": "var(--jfXUHL)",
    "variable": "var(--jfXUHL)"
  },
  "colors.colorPalette.neutral.action.strong.disabled": {
    "value": "var(--ftUQWo)",
    "variable": "var(--ftUQWo)"
  },
  "colors.colorPalette.action.strong.disabled": {
    "value": "var(--kpVEJA)",
    "variable": "var(--kpVEJA)"
  },
  "colors.colorPalette.strong.disabled": {
    "value": "var(--tVxhP)",
    "variable": "var(--tVxhP)"
  },
  "colors.colorPalette.brand.primary": {
    "value": "var(--eUETNv)",
    "variable": "var(--eUETNv)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--gbCbhR)",
    "variable": "var(--gbCbhR)"
  },
  "colors.colorPalette.brand.primary.hover": {
    "value": "var(--cQQcYY)",
    "variable": "var(--cQQcYY)"
  },
  "colors.colorPalette.primary.hover": {
    "value": "var(--cFYVhW)",
    "variable": "var(--cFYVhW)"
  },
  "colors.colorPalette.brand.primary.press": {
    "value": "var(--cezCqB)",
    "variable": "var(--cezCqB)"
  },
  "colors.colorPalette.primary.press": {
    "value": "var(--fBOWEv)",
    "variable": "var(--fBOWEv)"
  },
  "colors.colorPalette.brand.primary.active": {
    "value": "var(--hSVlLC)",
    "variable": "var(--hSVlLC)"
  },
  "colors.colorPalette.primary.active": {
    "value": "var(--SUJco)",
    "variable": "var(--SUJco)"
  },
  "colors.colorPalette.brand.primary.disabled": {
    "value": "var(--hBFvVq)",
    "variable": "var(--hBFvVq)"
  },
  "colors.colorPalette.primary.disabled": {
    "value": "var(--lkyJJo)",
    "variable": "var(--lkyJJo)"
  },
  "colors.colorPalette.brand.primary.subtlest": {
    "value": "var(--KGXxM)",
    "variable": "var(--KGXxM)"
  },
  "colors.colorPalette.primary.subtlest": {
    "value": "var(--jWljTG)",
    "variable": "var(--jWljTG)"
  },
  "colors.colorPalette.brand.primary.subtler": {
    "value": "var(--kfYNHt)",
    "variable": "var(--kfYNHt)"
  },
  "colors.colorPalette.primary.subtler": {
    "value": "var(--dCaMJf)",
    "variable": "var(--dCaMJf)"
  },
  "colors.colorPalette.brand.primary.subtle": {
    "value": "var(--hSvwCv)",
    "variable": "var(--hSvwCv)"
  },
  "colors.colorPalette.primary.subtle": {
    "value": "var(--gSZAmd)",
    "variable": "var(--gSZAmd)"
  },
  "colors.colorPalette.brand.secondary.subtler": {
    "value": "var(--fnhEqH)",
    "variable": "var(--fnhEqH)"
  },
  "colors.colorPalette.secondary.subtler": {
    "value": "var(--bSLnAF)",
    "variable": "var(--bSLnAF)"
  },
  "colors.colorPalette.brand.secondary.subtle": {
    "value": "var(--cAklid)",
    "variable": "var(--cAklid)"
  },
  "colors.colorPalette.secondary.subtle": {
    "value": "var(--dDwulP)",
    "variable": "var(--dDwulP)"
  },
  "colors.colorPalette.brand.secondary": {
    "value": "var(--kXIJcp)",
    "variable": "var(--kXIJcp)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--dDofdL)",
    "variable": "var(--dDofdL)"
  },
  "colors.colorPalette.brand.secondary.strong": {
    "value": "var(--fawKpn)",
    "variable": "var(--fawKpn)"
  },
  "colors.colorPalette.secondary.strong": {
    "value": "var(--ejWxYx)",
    "variable": "var(--ejWxYx)"
  },
  "colors.colorPalette.brand.secondary.stronger": {
    "value": "var(--dBMlhY)",
    "variable": "var(--dBMlhY)"
  },
  "colors.colorPalette.secondary.stronger": {
    "value": "var(--dZgHvK)",
    "variable": "var(--dZgHvK)"
  },
  "colors.colorPalette.stronger": {
    "value": "var(--fThiQh)",
    "variable": "var(--fThiQh)"
  },
  "colors.colorPalette.brand.secondary.strongest": {
    "value": "var(--igxsPh)",
    "variable": "var(--igxsPh)"
  },
  "colors.colorPalette.secondary.strongest": {
    "value": "var(--hrsqNH)",
    "variable": "var(--hrsqNH)"
  },
  "colors.colorPalette.success": {
    "value": "var(--kvWBga)",
    "variable": "var(--kvWBga)"
  },
  "colors.colorPalette.success.subtlest": {
    "value": "var(--ccazbx)",
    "variable": "var(--ccazbx)"
  },
  "colors.colorPalette.success.subtler": {
    "value": "var(--kVvtUg)",
    "variable": "var(--kVvtUg)"
  },
  "colors.colorPalette.success.subtle": {
    "value": "var(--kAGjGm)",
    "variable": "var(--kAGjGm)"
  },
  "colors.colorPalette.success.hover": {
    "value": "var(--brugPp)",
    "variable": "var(--brugPp)"
  },
  "colors.colorPalette.success.press": {
    "value": "var(--kHJwgk)",
    "variable": "var(--kHJwgk)"
  },
  "colors.colorPalette.success.disabled": {
    "value": "var(--bbrmuf)",
    "variable": "var(--bbrmuf)"
  },
  "colors.colorPalette.info.subtler": {
    "value": "var(--fmyNWt)",
    "variable": "var(--fmyNWt)"
  },
  "colors.colorPalette.info.subtle": {
    "value": "var(--jsYqgz)",
    "variable": "var(--jsYqgz)"
  },
  "colors.colorPalette.info": {
    "value": "var(--khMeQD)",
    "variable": "var(--khMeQD)"
  },
  "colors.colorPalette.info.strong": {
    "value": "var(--iNFmSR)",
    "variable": "var(--iNFmSR)"
  },
  "colors.colorPalette.info.stronger": {
    "value": "var(--cGFCuC)",
    "variable": "var(--cGFCuC)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--hmRtaX)",
    "variable": "var(--hmRtaX)"
  },
  "colors.colorPalette.warning.subtlest": {
    "value": "var(--eXmJWI)",
    "variable": "var(--eXmJWI)"
  },
  "colors.colorPalette.warning.subtle": {
    "value": "var(--kDmUvX)",
    "variable": "var(--kDmUvX)"
  },
  "colors.colorPalette.warning.subtler": {
    "value": "var(--fzHTcp)",
    "variable": "var(--fzHTcp)"
  },
  "colors.colorPalette.warning.hover": {
    "value": "var(--gYlbQY)",
    "variable": "var(--gYlbQY)"
  },
  "colors.colorPalette.warning.press": {
    "value": "var(--kXdSfN)",
    "variable": "var(--kXdSfN)"
  },
  "colors.colorPalette.warning.disabled": {
    "value": "var(--facTZW)",
    "variable": "var(--facTZW)"
  },
  "colors.colorPalette.critical": {
    "value": "var(--kvcdfS)",
    "variable": "var(--kvcdfS)"
  },
  "colors.colorPalette.critical.subtlest": {
    "value": "var(--dWZFeZ)",
    "variable": "var(--dWZFeZ)"
  },
  "colors.colorPalette.critical.subtle": {
    "value": "var(--cGcnmu)",
    "variable": "var(--cGcnmu)"
  },
  "colors.colorPalette.critical.subtler": {
    "value": "var(--bpzusE)",
    "variable": "var(--bpzusE)"
  },
  "colors.colorPalette.critical.hover": {
    "value": "var(--dcAYkd)",
    "variable": "var(--dcAYkd)"
  },
  "colors.colorPalette.critical.press": {
    "value": "var(--fnsHks)",
    "variable": "var(--fnsHks)"
  },
  "colors.colorPalette.critical.disabled": {
    "value": "var(--jceGpX)",
    "variable": "var(--jceGpX)"
  },
  "colors.colorPalette.custom.brown.subtle": {
    "value": "var(--dswFwF)",
    "variable": "var(--dswFwF)"
  },
  "colors.colorPalette.brown.subtle": {
    "value": "var(--eseCGz)",
    "variable": "var(--eseCGz)"
  },
  "colors.colorPalette.custom.brown": {
    "value": "var(--bYSpuZ)",
    "variable": "var(--bYSpuZ)"
  },
  "colors.colorPalette.brown": {
    "value": "var(--cvCiEv)",
    "variable": "var(--cvCiEv)"
  },
  "colors.colorPalette.custom.brown.strong": {
    "value": "var(--gHcXuT)",
    "variable": "var(--gHcXuT)"
  },
  "colors.colorPalette.brown.strong": {
    "value": "var(--eGpPUR)",
    "variable": "var(--eGpPUR)"
  },
  "colors.colorPalette.custom.cyan.subtle": {
    "value": "var(--chIRYC)",
    "variable": "var(--chIRYC)"
  },
  "colors.colorPalette.cyan.subtle": {
    "value": "var(--hIeOoY)",
    "variable": "var(--hIeOoY)"
  },
  "colors.colorPalette.custom.cyan": {
    "value": "var(--cKxjWW)",
    "variable": "var(--cKxjWW)"
  },
  "colors.colorPalette.cyan": {
    "value": "var(--fzlVww)",
    "variable": "var(--fzlVww)"
  },
  "colors.colorPalette.custom.cyan.strong": {
    "value": "var(--iZGNGo)",
    "variable": "var(--iZGNGo)"
  },
  "colors.colorPalette.cyan.strong": {
    "value": "var(--dXYCcy)",
    "variable": "var(--dXYCcy)"
  },
  "colors.colorPalette.custom.fuchsia.subtle": {
    "value": "var(--bndpbE)",
    "variable": "var(--bndpbE)"
  },
  "colors.colorPalette.fuchsia.subtle": {
    "value": "var(--kdWsEe)",
    "variable": "var(--kdWsEe)"
  },
  "colors.colorPalette.custom.fuchsia": {
    "value": "var(--YROtA)",
    "variable": "var(--YROtA)"
  },
  "colors.colorPalette.fuchsia": {
    "value": "var(--hySWhC)",
    "variable": "var(--hySWhC)"
  },
  "colors.colorPalette.custom.fuchsia.strong": {
    "value": "var(--exeeai)",
    "variable": "var(--exeeai)"
  },
  "colors.colorPalette.fuchsia.strong": {
    "value": "var(--bCeqTs)",
    "variable": "var(--bCeqTs)"
  },
  "colors.colorPalette.custom.lime.subtle": {
    "value": "var(--gQwANa)",
    "variable": "var(--gQwANa)"
  },
  "colors.colorPalette.lime.subtle": {
    "value": "var(--dUlASI)",
    "variable": "var(--dUlASI)"
  },
  "colors.colorPalette.custom.lime": {
    "value": "var(--igfchS)",
    "variable": "var(--igfchS)"
  },
  "colors.colorPalette.lime": {
    "value": "var(--hJsmxA)",
    "variable": "var(--hJsmxA)"
  },
  "colors.colorPalette.custom.lime.strong": {
    "value": "var(--dufruM)",
    "variable": "var(--dufruM)"
  },
  "colors.colorPalette.lime.strong": {
    "value": "var(--hZirwW)",
    "variable": "var(--hZirwW)"
  },
  "colors.colorPalette.custom.orange.subtle": {
    "value": "var(--dplHwj)",
    "variable": "var(--dplHwj)"
  },
  "colors.colorPalette.orange.subtle": {
    "value": "var(--cOhugx)",
    "variable": "var(--cOhugx)"
  },
  "colors.colorPalette.custom.orange": {
    "value": "var(--eRAMET)",
    "variable": "var(--eRAMET)"
  },
  "colors.colorPalette.custom.orange.strong": {
    "value": "var(--eMKrgt)",
    "variable": "var(--eMKrgt)"
  },
  "colors.colorPalette.orange.strong": {
    "value": "var(--wMZRz)",
    "variable": "var(--wMZRz)"
  },
  "colors.colorPalette.custom.pink.subtle": {
    "value": "var(--cNRhvj)",
    "variable": "var(--cNRhvj)"
  },
  "colors.colorPalette.pink.subtle": {
    "value": "var(--bjqrkl)",
    "variable": "var(--bjqrkl)"
  },
  "colors.colorPalette.custom.pink": {
    "value": "var(--kPTiUX)",
    "variable": "var(--kPTiUX)"
  },
  "colors.colorPalette.pink": {
    "value": "var(--cVTnJR)",
    "variable": "var(--cVTnJR)"
  },
  "colors.colorPalette.custom.pink.strong": {
    "value": "var(--gvyJiN)",
    "variable": "var(--gvyJiN)"
  },
  "colors.colorPalette.pink.strong": {
    "value": "var(--cLxhOz)",
    "variable": "var(--cLxhOz)"
  },
  "colors.colorPalette.custom.purple.subtle": {
    "value": "var(--eUrcap)",
    "variable": "var(--eUrcap)"
  },
  "colors.colorPalette.purple.subtle": {
    "value": "var(--bdRViH)",
    "variable": "var(--bdRViH)"
  },
  "colors.colorPalette.custom.purple": {
    "value": "var(--hYtsXh)",
    "variable": "var(--hYtsXh)"
  },
  "colors.colorPalette.purple": {
    "value": "var(--hVGqf)",
    "variable": "var(--hVGqf)"
  },
  "colors.colorPalette.custom.purple.strong": {
    "value": "var(--iGQrHH)",
    "variable": "var(--iGQrHH)"
  },
  "colors.colorPalette.purple.strong": {
    "value": "var(--jUmUHN)",
    "variable": "var(--jUmUHN)"
  },
  "colors.colorPalette.custom.rose.subtle": {
    "value": "var(--crHfUI)",
    "variable": "var(--crHfUI)"
  },
  "colors.colorPalette.rose.subtle": {
    "value": "var(--jhUYGu)",
    "variable": "var(--jhUYGu)"
  },
  "colors.colorPalette.custom.rose": {
    "value": "var(--eiNBcM)",
    "variable": "var(--eiNBcM)"
  },
  "colors.colorPalette.rose": {
    "value": "var(--cCvqBe)",
    "variable": "var(--cCvqBe)"
  },
  "colors.colorPalette.custom.rose.strong": {
    "value": "var(--hWLrQO)",
    "variable": "var(--hWLrQO)"
  },
  "colors.colorPalette.rose.strong": {
    "value": "var(--hIdGsw)",
    "variable": "var(--hIdGsw)"
  },
  "colors.colorPalette.custom.slate.subtle": {
    "value": "var(--bDwOLk)",
    "variable": "var(--bDwOLk)"
  },
  "colors.colorPalette.slate.subtle": {
    "value": "var(--ehRNaa)",
    "variable": "var(--ehRNaa)"
  },
  "colors.colorPalette.custom.slate": {
    "value": "var(--jfqDIc)",
    "variable": "var(--jfqDIc)"
  },
  "colors.colorPalette.slate": {
    "value": "var(--coQbjG)",
    "variable": "var(--coQbjG)"
  },
  "colors.colorPalette.custom.slate.strong": {
    "value": "var(--ioDMdi)",
    "variable": "var(--ioDMdi)"
  },
  "colors.colorPalette.slate.strong": {
    "value": "var(--cZSsVo)",
    "variable": "var(--cZSsVo)"
  },
  "colors.colorPalette.custom.teal.subtle": {
    "value": "var(--SBkdH)",
    "variable": "var(--SBkdH)"
  },
  "colors.colorPalette.teal.subtle": {
    "value": "var(--kVSRnV)",
    "variable": "var(--kVSRnV)"
  },
  "colors.colorPalette.custom.teal": {
    "value": "var(--iZJxdD)",
    "variable": "var(--iZJxdD)"
  },
  "colors.colorPalette.teal": {
    "value": "var(--ecTGvZ)",
    "variable": "var(--ecTGvZ)"
  },
  "colors.colorPalette.custom.teal.strong": {
    "value": "var(--eucdDd)",
    "variable": "var(--eucdDd)"
  },
  "colors.colorPalette.teal.strong": {
    "value": "var(--ciCHYr)",
    "variable": "var(--ciCHYr)"
  },
  "colors.colorPalette.custom.yellow.subtle": {
    "value": "var(--eGPCwT)",
    "variable": "var(--eGPCwT)"
  },
  "colors.colorPalette.yellow.subtle": {
    "value": "var(--jpfapV)",
    "variable": "var(--jpfapV)"
  },
  "colors.colorPalette.custom.yellow": {
    "value": "var(--jqkmxL)",
    "variable": "var(--jqkmxL)"
  },
  "colors.colorPalette.yellow": {
    "value": "var(--kFXnIx)",
    "variable": "var(--kFXnIx)"
  },
  "colors.colorPalette.custom.yellow.strong": {
    "value": "var(--lewulZ)",
    "variable": "var(--lewulZ)"
  },
  "colors.colorPalette.yellow.strong": {
    "value": "var(--gwwZcz)",
    "variable": "var(--gwwZcz)"
  },
  "colors.colorPalette.manny.neon": {
    "value": "var(--hrGdQb)",
    "variable": "var(--hrGdQb)"
  },
  "colors.colorPalette.manny.orange": {
    "value": "var(--gzvukB)",
    "variable": "var(--gzvukB)"
  },
  "colors.colorPalette.manny.violet": {
    "value": "var(--jPOnpI)",
    "variable": "var(--jPOnpI)"
  },
  "colors.colorPalette.manny.blue": {
    "value": "var(--gvbUrz)",
    "variable": "var(--gvbUrz)"
  },
  "colors.colorPalette.neutral.onFill": {
    "value": "var(--kSeEen)",
    "variable": "var(--kSeEen)"
  },
  "colors.colorPalette.onFill": {
    "value": "var(--oNvxj)",
    "variable": "var(--oNvxj)"
  },
  "colors.colorPalette.neutral.disabled": {
    "value": "var(--hegvbF)",
    "variable": "var(--hegvbF)"
  },
  "colors.colorPalette.neutral.action": {
    "value": "var(--gOVWYf)",
    "variable": "var(--gOVWYf)"
  },
  "colors.colorPalette.action": {
    "value": "var(--eOLVPr)",
    "variable": "var(--eOLVPr)"
  },
  "colors.colorPalette.neutral.action.dark": {
    "value": "var(--eumvAK)",
    "variable": "var(--eumvAK)"
  },
  "colors.colorPalette.action.dark": {
    "value": "var(--cGykUm)",
    "variable": "var(--cGykUm)"
  },
  "colors.colorPalette.dark": {
    "value": "var(--cLysdB)",
    "variable": "var(--cLysdB)"
  },
  "colors.colorPalette.neutral.action.disabled": {
    "value": "var(--fWDJnC)",
    "variable": "var(--fWDJnC)"
  },
  "colors.colorPalette.action.disabled": {
    "value": "var(--RQpmO)",
    "variable": "var(--RQpmO)"
  },
  "colors.colorPalette.neutral.action.onFill": {
    "value": "var(--jPGotY)",
    "variable": "var(--jPGotY)"
  },
  "colors.colorPalette.action.onFill": {
    "value": "var(--exSVlQ)",
    "variable": "var(--exSVlQ)"
  },
  "colors.colorPalette.brand.primary.dark": {
    "value": "var(--kOZOMO)",
    "variable": "var(--kOZOMO)"
  },
  "colors.colorPalette.primary.dark": {
    "value": "var(--cyIDXs)",
    "variable": "var(--cyIDXs)"
  },
  "colors.colorPalette.brand.secondary.dark": {
    "value": "var(--jDQLIE)",
    "variable": "var(--jDQLIE)"
  },
  "colors.colorPalette.secondary.dark": {
    "value": "var(--IOpjC)",
    "variable": "var(--IOpjC)"
  },
  "colors.colorPalette.brand.secondary.disabled": {
    "value": "var(--gpkFlU)",
    "variable": "var(--gpkFlU)"
  },
  "colors.colorPalette.secondary.disabled": {
    "value": "var(--avdUK)",
    "variable": "var(--avdUK)"
  },
  "colors.colorPalette.success.dark": {
    "value": "var(--kaJbnL)",
    "variable": "var(--kaJbnL)"
  },
  "colors.colorPalette.warning.dark": {
    "value": "var(--jSMdaG)",
    "variable": "var(--jSMdaG)"
  },
  "colors.colorPalette.critical.dark": {
    "value": "var(--cPaMlv)",
    "variable": "var(--cPaMlv)"
  },
  "colors.colorPalette.neutral.action.press": {
    "value": "var(--kfAjax)",
    "variable": "var(--kfAjax)"
  },
  "colors.colorPalette.action.press": {
    "value": "var(--hHGcVZ)",
    "variable": "var(--hHGcVZ)"
  },
  "colors.colorPalette.neutral.action.focus": {
    "value": "var(--GsHBG)",
    "variable": "var(--GsHBG)"
  },
  "colors.colorPalette.action.focus": {
    "value": "var(--jPoqNO)",
    "variable": "var(--jPoqNO)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--iAisux)",
    "variable": "var(--iAisux)"
  },
  "colors.colorPalette.brand.primary.strong": {
    "value": "var(--elHLxZ)",
    "variable": "var(--elHLxZ)"
  },
  "colors.colorPalette.primary.strong": {
    "value": "var(--eCoHnL)",
    "variable": "var(--eCoHnL)"
  },
  "colors.colorPalette.brand.primary.focus": {
    "value": "var(--dMQgea)",
    "variable": "var(--dMQgea)"
  },
  "colors.colorPalette.primary.focus": {
    "value": "var(--hSkEWM)",
    "variable": "var(--hSkEWM)"
  },
  "colors.colorPalette.success.strong": {
    "value": "var(--gMtFZk)",
    "variable": "var(--gMtFZk)"
  },
  "colors.colorPalette.success.focus": {
    "value": "var(--eePsOj)",
    "variable": "var(--eePsOj)"
  },
  "colors.colorPalette.warning.strong": {
    "value": "var(--dgQuLB)",
    "variable": "var(--dgQuLB)"
  },
  "colors.colorPalette.warning.focus": {
    "value": "var(--fGUrnm)",
    "variable": "var(--fGUrnm)"
  },
  "colors.colorPalette.critical.strong": {
    "value": "var(--dfxtGU)",
    "variable": "var(--dfxtGU)"
  },
  "colors.colorPalette.critical.focus": {
    "value": "var(--cChBfT)",
    "variable": "var(--cChBfT)"
  },
  "colors.colorPalette.info.dark": {
    "value": "var(--gJtRsC)",
    "variable": "var(--gJtRsC)"
  },
  "colors.colorPalette.disabled.brand.primary": {
    "value": "var(--cwMpJa)",
    "variable": "var(--cwMpJa)"
  },
  "colors.colorPalette.disabled.brand.secondary": {
    "value": "var(--iUvccY)",
    "variable": "var(--iUvccY)"
  },
  "colors.colorPalette.disabled.success": {
    "value": "var(--hXtHtP)",
    "variable": "var(--hXtHtP)"
  },
  "colors.colorPalette.disabled.warning": {
    "value": "var(--hbwidG)",
    "variable": "var(--hbwidG)"
  },
  "colors.colorPalette.disabled.critical": {
    "value": "var(--cNbHmD)",
    "variable": "var(--cNbHmD)"
  },
  "colors.colorPalette.neutral.subtler": {
    "value": "var(--fDStka)",
    "variable": "var(--fDStka)"
  },
  "colors.colorPalette.xs": {
    "value": "var(--hIoiqG)",
    "variable": "var(--hIoiqG)"
  },
  "colors.colorPalette.sm": {
    "value": "var(--bDBXpz)",
    "variable": "var(--bDBXpz)"
  },
  "colors.colorPalette.md": {
    "value": "var(--dAXWKY)",
    "variable": "var(--dAXWKY)"
  },
  "colors.colorPalette.lg": {
    "value": "var(--EfSte)",
    "variable": "var(--EfSte)"
  },
  "colors.colorPalette.xl": {
    "value": "var(--DUHZZ)",
    "variable": "var(--DUHZZ)"
  },
  "colors.colorPalette.inverted.xs": {
    "value": "var(--gwNJdY)",
    "variable": "var(--gwNJdY)"
  },
  "colors.colorPalette.inverted.sm": {
    "value": "var(--eZpgcd)",
    "variable": "var(--eZpgcd)"
  },
  "colors.colorPalette.inverted.md": {
    "value": "var(--bXynCC)",
    "variable": "var(--bXynCC)"
  },
  "colors.colorPalette.inverted.lg": {
    "value": "var(--gyhUaE)",
    "variable": "var(--gyhUaE)"
  },
  "colors.colorPalette.inverted.xl": {
    "value": "var(--dnWcSr)",
    "variable": "var(--dnWcSr)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar